function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill } from "../../components/analytics-kit";
import { Link } from "react-router-dom";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import account from "../../data/account";
import ServiceFactory from "../../service";
import endpoints from "../../endpoints";
import Auth from "../../functions/authenticate";
import { adSvc } from "./common";
import PostalBubbleMap from "../market-intelligence/postal-bubble-map";
import ZIP3 from "./zip3-centroids";

/*
 * Flight Builder v2 (beta) — the approved redesign wired to the real flight
 * contract. Parallel to flight-wizard.jsx behind a Plunk-admin entry until
 * verified, then it becomes the default New Flight route.
 *   POST /flights (draft) → creative slot uploads → validate → submit → progress
 */
function locSvc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
const CHANNELS = [["Display", "Display", "Responsive display across the web"], ["Retarget", "Retargeting", "Re-engage past visitors"], ["Search", "Search", "Intent keywords on Google"], ["Social", "Social", "Feed & stories (Meta)"], ["YouTube", "YouTube", "Skippable & bumper"], ["CTV", "CTV / OTT", "TV screens via Google Video"], ["SocialVideo", "Social Video", "Hosted video → Meta"]];
const STEPS = [["Basics", "Name, goal, dates"], ["Channels", "Where it runs"], ["Markets & geo", "Who you reach"], ["Audiences", "Segments & tiers"], ["Demographics", "Age, gender, income"], ["Creative", "Asset library"], ["Budget", "Daily spend"], ["Review", "Launch"]];

// Demographic option sets — the human labels the backend already accepts and
// translates to provider targeting (Google age/income enums, Facebook age
// min/max + gender). Languages submit Google language CODES ("en"/"es"…),
// matched by LanguageService.GetByLocaleAsync.
const AGES = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
const GENDERS = ["All", "Female", "Male"];
const INCOMES = ["Top 10%", "11-20%", "21-30%", "31-40%", "41-50%", "Lower 50%"];
const LANGS = [["English", "en"], ["Spanish", "es"], ["French", "fr"], ["German", "de"], ["Portuguese", "pt"], ["Chinese", "zh_CN"]];

// Metro-name → [lat,lng] fallback so markets pin even when /location/places
// carries no coordinates. Preferred source is always the API's own lat/lng.
const METROS = {
  "atlanta": [33.75, -84.39],
  "austin": [30.27, -97.74],
  "chicago": [41.88, -87.63],
  "dallas": [32.78, -96.80],
  "fort worth": [32.76, -97.33],
  "houston": [29.76, -95.37],
  "los angeles": [34.05, -118.24],
  "new york": [40.71, -74.01],
  "phoenix": [33.45, -112.07],
  "scottsdale": [33.49, -111.92],
  "san francisco": [37.77, -122.42],
  "san jose": [37.34, -121.89],
  "miami": [25.76, -80.19],
  "south florida": [26.12, -80.14],
  "fort lauderdale": [26.12, -80.14],
  "broward": [26.19, -80.14],
  "boca raton": [26.36, -80.08],
  "west palm": [26.71, -80.05],
  "charlotte": [35.23, -80.84],
  "raleigh": [35.78, -78.64],
  "nc corridor": [35.77, -78.86],
  "boston": [42.36, -71.06],
  "seattle": [47.61, -122.33],
  "denver": [39.74, -104.99],
  "las vegas": [36.17, -115.14],
  "san diego": [32.72, -117.16],
  "washington": [38.90, -77.04],
  "philadelphia": [39.95, -75.17],
  "detroit": [42.33, -83.05],
  "minneapolis": [44.98, -93.27],
  "nashville": [36.16, -86.78],
  "orlando": [28.54, -81.38],
  "tampa": [27.95, -82.46],
  "fort myers": [26.64, -81.87],
  "sarasota": [27.34, -82.53],
  "naples": [26.14, -81.79],
  "wellen park": [27.05, -82.30],
  "portland": [45.52, -122.68],
  "san antonio": [29.42, -98.49],
  "sacramento": [38.58, -121.49],
  "st louis": [38.63, -90.20],
  "st. louis": [38.63, -90.20],
  "kansas city": [39.10, -94.58],
  "columbus": [39.96, -82.99],
  "indianapolis": [39.77, -86.16],
  "cleveland": [41.50, -81.69],
  "pittsburgh": [40.44, -79.99],
  "cincinnati": [39.10, -84.51],
  "baltimore": [39.29, -76.61],
  "salt lake": [40.76, -111.89],
  "jacksonville": [30.33, -81.66],
  "memphis": [35.15, -90.05],
  "louisville": [38.25, -85.76],
  "milwaukee": [43.04, -87.91],
  "oklahoma city": [35.47, -97.52],
  "new orleans": [29.95, -90.07],
  "richmond": [37.54, -77.44],
  "hartford": [41.76, -72.67],
  "buffalo": [42.89, -78.88],
  "albany": [42.65, -73.76],
  "providence": [41.82, -71.41]
};
function geocodeMarket(name) {
  const n = String(name || "").toLowerCase();
  let best = null,
    bestLen = 0;
  Object.keys(METROS).forEach(k => {
    if (n.includes(k) && k.length > bestLen) {
      best = METROS[k];
      bestLen = k.length;
    }
  });
  return best;
}
// Centroid a market from its ZIP list via the ZIP3-prefix centroid table.
function centroidFromZips(zips) {
  let lat = 0,
    lng = 0,
    n = 0;
  (zips || []).forEach(z => {
    const c = ZIP3[String(z).slice(0, 3)];
    if (c) {
      lat += c[0];
      lng += c[1];
      n++;
    }
  });
  return n ? [lat / n, lng / n] : null;
}
const CSS = `
.fb-wrap{display:grid;grid-template-columns:210px minmax(0,1fr) 300px;gap:0;align-items:start}
.fb-rail,.fb-main,.fb-sum{align-self:start}
@media(max-width:1150px){.fb-wrap{grid-template-columns:190px minmax(0,1fr)}.fb-sum{display:none}}
@media(max-width:800px){.fb-wrap{grid-template-columns:1fr}.fb-rail{display:none}}
.fb-rail{position:sticky;top:0;padding:24px 10px;border-right:1px solid var(--plk-border,#e7e2dc)}
.fb-step{display:flex;gap:10px;align-items:flex-start;padding:9px 10px;border-radius:8px;cursor:pointer;color:var(--plk-text-muted,#7d7b88)}
.fb-step:hover{background:var(--plk-surface-alt,#f4f1ee)}
.fb-step.on{background:var(--plk-accent-soft,#ffece9);color:var(--plk-text,#1c1b22)}
.fb-num{width:22px;height:22px;border-radius:50%;border:1.5px solid var(--plk-border-strong,#ded7cf);display:grid;place-items:center;font-size:11.5px;font-weight:700;flex:none;color:var(--plk-text-muted,#7d7b88);background:var(--plk-surface,#fff)}
.fb-step.on .fb-num{background:var(--plk-accent,#ff6358);border-color:var(--plk-accent,#ff6358);color:#fff}
.fb-step.done .fb-num{background:var(--plk-success,#2f9e5f);border-color:var(--plk-success,#2f9e5f);color:#fff}
.fb-lbl{font-weight:600;font-size:13px}.fb-sub{font-size:11px;color:var(--plk-text-muted,#7d7b88)}
.fb-main{padding:24px 26px 60px;min-height:60vh;margin-top:0}
.fb-h1{font-size:21px;font-weight:700;letter-spacing:-.01em;margin:0}
.fb-lead{color:var(--plk-text-muted,#7d7b88);margin:5px 0 20px;max-width:62ch}
.fb-card{background:var(--plk-surface,#fff);border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;padding:18px 20px;margin-bottom:14px;max-width:660px}
.fb-field{margin-bottom:14px}.fb-field label{display:block;font-size:12px;font-weight:600;color:var(--plk-text-muted,#7d7b88);margin-bottom:5px}
.fb-input{width:100%;padding:9px 11px;border:1px solid var(--plk-border-strong,#ded7cf);border-radius:8px;background:var(--plk-surface,#fff);color:var(--plk-text,#1c1b22);font-size:14px;font-family:inherit}
.fb-input:focus{outline:none;border-color:var(--plk-accent,#ff6358);box-shadow:0 0 0 3px var(--plk-accent-soft,#ffece9)}
.fb-row2{display:grid;grid-template-columns:1fr 1fr;gap:14px}@media(max-width:560px){.fb-row2{grid-template-columns:1fr}}
.fb-tog,.fb-field label.fb-tog{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:500;color:var(--plk-text,#1c1b22);cursor:pointer;padding:4px 0;margin-bottom:0}
.fb-tog input{width:16px;height:16px;margin:0;accent-color:var(--plk-accent,#ff6358);flex:none}
.fb-chgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:11px;max-width:740px}@media(max-width:760px){.fb-chgrid{grid-template-columns:repeat(2,1fr)}}
.fb-ch{border:1.5px solid var(--plk-border,#e7e2dc);border-radius:11px;padding:13px;cursor:pointer;background:var(--plk-surface,#fff);position:relative}
.fb-ch:hover{border-color:var(--plk-border-strong,#ded7cf)}
.fb-ch.on{border-color:var(--plk-accent,#ff6358);background:var(--plk-accent-soft,#ffece9)}
.fb-ci{width:32px;height:32px;border-radius:9px;background:var(--plk-surface-alt,#f4f1ee);display:grid;place-items:center;margin-bottom:9px;color:var(--plk-text-muted,#7d7b88)}
.fb-ch.on .fb-ci{background:#fff;color:var(--plk-accent-ink,#e0473c)}
.fb-ch h4{margin:0;font-size:13.5px}.fb-ch p{margin:3px 0 0;font-size:11.5px;color:var(--plk-text-muted,#7d7b88)}
.fb-ch .tk{position:absolute;top:10px;right:10px;width:18px;height:18px;border-radius:50%;background:var(--plk-accent,#ff6358);color:#fff;display:none;place-items:center;font-size:12px}
.fb-ch.on .tk{display:grid}
.fb-geo{display:grid;grid-template-columns:1.3fr 1fr;gap:18px;align-items:start}@media(max-width:900px){.fb-geo{grid-template-columns:1fr}}
.fb-mapbox{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;overflow:hidden;background:var(--plk-surface-alt,#f4f1ee);min-height:300px;position:sticky;top:24px;display:grid;place-items:center}
.fb-mapbox>div{width:100%}
.fb-mapempty{color:var(--plk-text-muted,#7d7b88);font-size:12.5px;text-align:center;padding:30px}
.fb-mkt{display:flex;align-items:center;gap:11px;padding:10px 12px;border:1px solid var(--plk-border,#e7e2dc);border-radius:8px;margin-bottom:8px}
.fb-mkt.on{border-color:var(--plk-accent-line,#ffd4cf);background:var(--plk-accent-soft,#ffece9)}
.fb-chk{width:18px;height:18px;border-radius:5px;border:1.5px solid var(--plk-border-strong,#ded7cf);flex:none;display:grid;place-items:center;background:var(--plk-surface,#fff);cursor:pointer}
.fb-mkt.on .fb-chk{background:var(--plk-accent,#ff6358);border-color:var(--plk-accent,#ff6358);color:#fff}
.fb-mkt .nm{font-weight:600;font-size:13px}.fb-mkt .zp{font-size:11px;color:var(--plk-text-muted,#7d7b88)}
.fb-mkt .bud{margin-left:auto;font-family:ui-monospace,Menlo,monospace;font-size:11.5px;color:var(--plk-text-muted,#7d7b88);background:var(--plk-surface-alt,#f4f1ee);padding:3px 8px;border-radius:6px}
.fb-aud{display:grid;grid-template-columns:1.3fr 1fr;gap:18px}@media(max-width:900px){.fb-aud{grid-template-columns:1fr}}
.fb-catrow{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}
.fb-catchip{display:inline-flex;align-items:center;gap:6px;padding:5px 11px;border-radius:16px;border:1px solid var(--plk-border-strong,#ded7cf);background:var(--plk-surface,#fff);color:var(--plk-text-muted,#7d7b88);font-size:12px;font-weight:600;cursor:pointer}
.fb-catchip:hover{border-color:var(--plk-accent-line,#ffd4cf)}
.fb-catchip.on{background:var(--plk-accent,#ff6358);border-color:var(--plk-accent,#ff6358);color:#fff}
.fb-catchip .ct{font-size:11px;font-family:ui-monospace,Menlo,monospace;opacity:.8}
.fb-segs{border:1px solid var(--plk-border,#e7e2dc);border-radius:10px;overflow:hidden;margin-top:10px}
.fb-segcat{padding:7px 13px;background:var(--plk-surface-alt,#f4f1ee);font-size:11px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--plk-text-muted,#7d7b88);border-top:1px solid var(--plk-border,#e7e2dc)}
.fb-segcat:first-child{border-top:none}
.fb-seg{display:flex;align-items:center;gap:11px;padding:10px 13px;cursor:pointer;border-top:1px solid var(--plk-border,#e7e2dc)}
.fb-seg:hover{background:var(--plk-accent-soft,#ffece9)}
.fb-seg.added{cursor:default;opacity:.65}.fb-seg.added:hover{background:none}
.fb-seg.added .pl{background:var(--plk-success,#2f9e5f);border-color:var(--plk-success,#2f9e5f);color:#fff}
.fb-seg .nm{font-weight:600;font-size:13px}.fb-seg .mt{font-size:11.5px;color:var(--plk-text-muted,#7d7b88)}
.fb-seg .sz{margin-left:auto;font-family:ui-monospace,Menlo,monospace;font-size:11.5px;color:var(--plk-text-muted,#7d7b88)}
.fb-seg .pl{width:24px;height:24px;border-radius:6px;border:1px solid var(--plk-border-strong,#ded7cf);display:grid;place-items:center;color:var(--plk-accent-ink,#e0473c);font-weight:700}
.fb-chips{display:flex;flex-wrap:wrap;gap:8px;min-height:30px}
.fb-chip{display:inline-flex;align-items:center;gap:7px;padding:5px 6px 5px 11px;border-radius:18px;background:var(--plk-surface-alt,#f4f1ee);border:1px solid var(--plk-border,#e7e2dc);font-size:12.5px;font-weight:600}
.fb-chip.excl{background:var(--plk-danger-soft,#fbe6e5);border-color:transparent;color:var(--plk-danger,#d64541)}
.fb-x{cursor:pointer;width:17px;height:17px;border-radius:50%;background:rgba(0,0,0,.08);display:grid;place-items:center;font-size:12px;color:var(--plk-text-muted,#7d7b88)}
.fb-eyebrow{font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--plk-text-muted,#7d7b88);margin:14px 0 6px}
.fb-gaugebar{height:11px;border-radius:8px;background:var(--plk-surface-alt,#f4f1ee);border:1px solid var(--plk-border,#e7e2dc);overflow:hidden}
.fb-gaugefill{height:100%;background:linear-gradient(90deg,#ffb35c,var(--plk-accent,#ff6358));transition:width .4s}
.fb-gaugelab{display:flex;justify-content:space-between;font-size:11.5px;color:var(--plk-text-muted,#7d7b88);margin-top:6px}
.fb-tiers{display:flex;gap:8px;margin-top:8px}
.fb-tier{flex:1;border:1px dashed var(--plk-border-strong,#ded7cf);border-radius:8px;padding:9px;text-align:center;font-size:12px;cursor:pointer;color:var(--plk-text-muted,#7d7b88)}
.fb-tier:hover{border-color:var(--plk-accent-line,#ffd4cf)}
.fb-tier.on{border-style:solid;border-color:var(--plk-accent,#ff6358);background:var(--plk-accent-soft,#ffece9);color:var(--plk-text,#1c1b22)}
.fb-tier b{display:block;color:var(--plk-accent-ink,#e0473c);font-family:ui-monospace,Menlo,monospace}
.fb-tier{position:relative}
.fb-tierx{position:absolute;top:4px;right:6px;width:16px;height:16px;border-radius:50%;background:rgba(0,0,0,.08);display:grid;place-items:center;font-size:11px;color:var(--plk-text-muted,#7d7b88);cursor:pointer}
.fb-tierx:hover{background:var(--plk-danger,#d64541);color:#fff}
.fb-plc{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:12px}
.fb-p{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;padding:12px;background:var(--plk-surface,#fff)}
.fb-p .ph{display:flex;flex-direction:column;gap:2px;margin-bottom:10px;min-height:34px}
.fb-p .ph b{font-size:12.5px;line-height:1.25}.fb-p .ph span{font-size:10.5px;color:var(--plk-text-muted,#7d7b88);font-family:ui-monospace,Menlo,monospace;white-space:nowrap;letter-spacing:-0.2px}
.fb-slot{aspect-ratio:1.6;border-radius:8px;border:1.5px dashed var(--plk-border-strong,#ded7cf);display:grid;place-items:center;color:var(--plk-text-muted,#7d7b88);font-size:12px;text-align:center;background:var(--plk-surface-alt,#f4f1ee);cursor:pointer;overflow:hidden;position:relative}
.fb-slot.filled{border-style:solid;border-color:var(--plk-success,#2f9e5f)}
.fb-slot img{width:100%;height:100%;object-fit:cover}
.fb-slot input{display:none}
.fb-slotx{position:absolute;top:4px;right:5px;z-index:2;width:20px;height:20px;border-radius:50%;background:rgba(28,27,34,.72);color:#fff;font-size:15px;line-height:20px;text-align:center;cursor:pointer}
.fb-slotx:hover{background:var(--plk-danger,#b42318)}
.fb-slot-err{margin-top:6px;color:var(--plk-danger,#b42318);font-size:11.5px;font-weight:600;line-height:1.3}
.fb-thumb{position:relative;width:100%;height:100%;display:block}
.fb-thumb img{width:100%;height:100%;object-fit:cover}
.fb-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:38px;height:38px;border-radius:50%;background:rgba(0,0,0,.55);display:grid;place-items:center;pointer-events:none}
.fb-play .material-icons{color:#fff;font-size:26px;margin-left:2px}
.fb-vlink{padding:4px 2px}
.fb-vl-label{display:block;font-weight:700;font-size:12px;margin-bottom:5px;color:var(--plk-text,#1c1b22)}
.fb-vl-prev{margin-top:14px;display:flex;align-items:center;gap:12px}
.fb-vl-prev .fb-thumb{width:150px;height:84px;border-radius:8px;overflow:hidden;flex:0 0 auto;border:1.5px solid var(--plk-success,#2f9e5f)}
.fb-vl-err{margin-top:10px;color:var(--plk-danger,#b42318);font-size:12.5px;font-weight:600}
.fb-callout{display:flex;gap:10px;padding:11px 14px;border-radius:8px;background:var(--plk-accent-soft,#ffece9);border:1px solid var(--plk-accent-line,#ffd4cf);color:var(--plk-accent-ink,#e0473c);font-size:12.5px;margin-top:14px;max-width:720px}
.fb-slider{width:100%;accent-color:var(--plk-accent,#ff6358)}
.fb-actions{display:flex;gap:10px;align-items:center;margin-top:12px}
.fb-btn{border:1px solid var(--plk-border-strong,#ded7cf);background:var(--plk-surface,#fff);color:var(--plk-text,#1c1b22);padding:9px 16px;border-radius:8px;font-weight:600;font-size:13px}
.fb-btn.primary{background:var(--plk-accent,#ff6358);border-color:var(--plk-accent,#ff6358);color:#fff}
.fb-btn:disabled{opacity:.5}
.fb-note{font-size:12.5px;color:var(--plk-text-muted,#7d7b88)}
.fb-sum{position:sticky;top:0;padding:24px 16px;border-left:1px solid var(--plk-border,#e7e2dc)}
.fb-sumcard{background:var(--plk-surface,#fff);border:1px solid var(--plk-border,#e7e2dc);border-radius:14px;padding:16px}
.fb-sumcard h4{margin:0 0 8px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--plk-text-muted,#7d7b88)}
.fb-sr{display:flex;justify-content:space-between;padding:8px 0;border-top:1px solid var(--plk-border,#e7e2dc);font-size:13px}.fb-sr .v{font-weight:600}
.fb-schip{display:inline-block;font-size:11px;font-weight:600;padding:2px 8px;border-radius:12px;background:var(--plk-surface-alt,#f4f1ee);margin:0 4px 4px 0}
.fb-reach{margin-top:12px;padding:13px;border-radius:10px;background:var(--plk-accent-soft,#ffece9);border:1px solid var(--plk-accent-line,#ffd4cf)}
.fb-reach .big{font-size:24px;font-weight:800;font-family:ui-monospace,Menlo,monospace;color:var(--plk-accent-ink,#e0473c)}
.fb-beta{display:inline-block;font-size:10px;font-weight:700;letter-spacing:.05em;padding:2px 7px;border-radius:10px;background:var(--plk-accent,#ff6358);color:#fff;margin-left:8px;vertical-align:middle}
/* creative groups + asset library */
.fb-cgroup{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;padding:16px;margin-bottom:14px;background:var(--plk-surface,#fff)}
.fb-cghead{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:12px}
.fb-cgname{font-weight:700;font-size:14px;display:flex;align-items:center;gap:8px}
.fb-cgset{width:22px;height:22px;border-radius:50%;background:var(--plk-accent-soft,#ffece9);color:var(--plk-accent-ink,#e0473c);display:grid;place-items:center;font-size:11px;font-weight:800}
.fb-plc .ph b{font-size:12.5px}.fb-plc .ph span{font-size:10.5px;color:var(--plk-text-muted,#7d7b88);font-family:ui-monospace,Menlo,monospace}
.fb-slot img{width:100%;height:100%;object-fit:cover}
.fb-slot .snm{position:relative;z-index:1;padding:6px;font-weight:700;font-size:12px;text-align:center;color:#fff;text-shadow:0 1px 3px rgba(0,0,0,.5)}
.fb-addset{border:1.5px dashed var(--plk-border-strong,#ded7cf);background:transparent;color:var(--plk-text,#1c1b22);width:100%;justify-content:center}
.fb-ov{position:fixed;inset:0;background:rgba(20,19,24,.5);z-index:80;display:flex;align-items:center;justify-content:center;padding:24px}
.fb-modal{background:var(--plk-surface,#fff);border:1px solid var(--plk-border,#e7e2dc);border-radius:16px;box-shadow:0 20px 48px rgba(28,27,34,.22);width:min(880px,96vw);max-height:88vh;display:flex;flex-direction:column;overflow:hidden}
.fb-mh{display:flex;align-items:center;justify-content:space-between;padding:15px 18px;border-bottom:1px solid var(--plk-border,#e7e2dc)}
.fb-mh h3{margin:0;font-size:16px}
.fb-mtabs{display:flex;gap:4px}
.fb-mtab{padding:6px 12px;border-radius:8px;font-size:12.5px;font-weight:600;color:var(--plk-text-muted,#7d7b88);cursor:pointer;background:transparent;border:none}
.fb-mtab.on{background:var(--plk-accent-soft,#ffece9);color:var(--plk-accent-ink,#e0473c)}
.fb-mbody{padding:18px;overflow:auto}
.fb-mf{display:flex;align-items:center;justify-content:space-between;padding:13px 18px;border-top:1px solid var(--plk-border,#e7e2dc);background:var(--plk-surface-alt,#f4f1ee)}
.fb-close{width:32px;height:32px;border-radius:8px;border:1px solid var(--plk-border,#e7e2dc);background:var(--plk-surface,#fff);display:grid;place-items:center;color:var(--plk-text-muted,#7d7b88);cursor:pointer;font-size:16px}
.fb-drop{border:2px dashed var(--plk-border-strong,#ded7cf);border-radius:12px;padding:30px;text-align:center;color:var(--plk-text-muted,#7d7b88);cursor:pointer;background:var(--plk-surface-alt,#f4f1ee);display:block}
.fb-drop:hover{border-color:var(--plk-accent,#ff6358);background:var(--plk-accent-soft,#ffece9);color:var(--plk-accent-ink,#e0473c)}
.fb-drop input{display:none}
.fb-agrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(128px,1fr));gap:12px}
.fb-asset{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;overflow:hidden;background:var(--plk-surface,#fff);cursor:pointer;position:relative}
.fb-asset.sel{outline:2px solid var(--plk-accent,#ff6358);outline-offset:-2px}
.fb-asset .th{aspect-ratio:1.2;display:grid;place-items:center;color:#fff;font-weight:700;font-size:11px;text-align:center;padding:6px;overflow:hidden}
.fb-asset .th img{width:100%;height:100%;object-fit:cover}
.fb-asset .amt{padding:6px 8px;font-size:11px;color:var(--plk-text-muted,#7d7b88);display:flex;justify-content:space-between;align-items:center}
.fb-asset .amt b{color:var(--plk-text,#1c1b22);font-weight:600;font-size:11px}
.fb-ar{position:absolute;top:6px;left:6px;background:rgba(0,0,0,.55);color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:5px;font-family:ui-monospace,Menlo,monospace}
.fb-asset .sm{position:absolute;top:6px;right:6px;width:20px;height:20px;border-radius:50%;background:var(--plk-accent,#ff6358);color:#fff;display:none;place-items:center;font-size:12px}
.fb-asset.sel .sm{display:grid}
.fb-empty{padding:26px;text-align:center;color:var(--plk-text-muted,#7d7b88);font-size:13px}
.fb-lltag{display:inline-block;font-size:9.5px;font-weight:800;letter-spacing:.04em;padding:1px 5px;border-radius:5px;background:var(--plk-accent-soft,#ffece9);color:var(--plk-accent-ink,#e0473c);margin-left:7px;vertical-align:middle}
.fb-llbtn{border:1px solid var(--plk-border-strong,#ded7cf);background:var(--plk-surface,#fff);color:var(--plk-accent-ink,#e0473c);font-weight:600;font-size:11px;padding:4px 9px;border-radius:14px;margin-left:8px;cursor:pointer;white-space:nowrap}
.fb-llbtn:hover{border-color:var(--plk-accent,#ff6358);background:var(--plk-accent-soft,#ffece9)}
.fb-seg.building{background:var(--plk-accent-soft,#ffece9);cursor:default}
.fb-buildtxt{color:var(--plk-accent-ink,#e0473c);font-weight:700;display:inline-flex;align-items:center;gap:6px}
.fb-spin{width:12px;height:12px;border:2px solid var(--plk-accent,#ff6358);border-right-color:transparent;border-radius:50%;display:inline-block;animation:fbspin .7s linear infinite;vertical-align:middle}
@keyframes fbspin{to{transform:rotate(360deg)}}
.fb-buildbanner{display:flex;align-items:center;gap:9px;padding:11px 14px;margin-bottom:14px;border-radius:10px;background:var(--plk-accent-soft,#ffece9);border:1px solid var(--plk-accent-line,#ffd4cf);color:var(--plk-accent-ink,#e0473c);font-size:13px;font-weight:600}
/* ── launch progress ── */
@keyframes fb-fade{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}
.fb-prog{max-width:600px;margin:0 auto;padding:8px 0 48px;animation:fb-fade .3s ease}
.fb-prog-hero{text-align:center;padding:18px 0 26px}
.fb-ring{width:104px;height:104px;border-radius:50%;margin:0 auto 18px;display:grid;place-items:center;background:conic-gradient(var(--plk-accent,#ff6358) calc(var(--pct,0)*1%),var(--plk-border,#e7e2dc) 0);transition:background .6s ease}
.fb-ring.done{background:conic-gradient(var(--plk-success,#2f9e5f) 100%,var(--plk-success,#2f9e5f) 0)}
.fb-ring.fail{background:conic-gradient(var(--plk-danger,#d64541) 100%,var(--plk-danger,#d64541) 0)}
.fb-h1.fail{color:var(--plk-danger,#b42318)}
.wa-pill.danger.solid{background:var(--plk-danger,#d64541);color:#fff;font-weight:700}
.fb-ring-in{width:82px;height:82px;border-radius:50%;background:var(--plk-surface,#fff);display:grid;place-items:center}
.fb-ring .fb-pct{font-size:21px;font-weight:700;font-family:ui-monospace,Menlo,monospace;color:var(--plk-text,#1c1b22)}
.fb-prog-list{border:1px solid var(--plk-border,#e7e2dc);border-radius:12px;overflow:hidden;background:var(--plk-surface,#fff)}
.fb-prog-row{display:flex;align-items:center;gap:12px;padding:12px 14px;border-top:1px solid var(--plk-border,#e7e2dc);flex-wrap:wrap}
.fb-prog-row:first-child{border-top:none}
.fb-prog-meta{flex:1;min-width:0}
.fb-prog-meta b{display:block;font-size:13px;color:var(--plk-text,#1c1b22)}
.fb-prog-meta span{font-size:11.5px;color:var(--plk-text-muted,#7d7b88)}
.fb-prog-err{flex-basis:100%;margin:2px 0 0 38px;font-size:11.5px;color:var(--plk-danger,#b42318);line-height:1.45}
.fb-prog-err b{color:var(--plk-danger,#b42318)}
.fb-prog-st{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.4px;white-space:nowrap}
.fb-prog-st.created{color:var(--plk-success,#2f9e5f)}
.fb-prog-st.failed{color:var(--plk-danger,#b42318)}
.fb-prog-st.creating,.fb-prog-st.scheduled{color:var(--plk-text-muted,#7d7b88)}
.fb-prog.wide{max-width:1100px}
.fb-launch-lead{margin:0 0 12px;font-size:13px;color:var(--plk-text-muted,#7d7b88);line-height:1.5;max-width:70ch}
.fb-bar{height:6px;border-radius:999px;background:var(--plk-border,#e7e2dc);overflow:hidden;margin:0 0 16px}
.fb-bar-in{display:block;height:100%;background:var(--plk-accent,#ff6358);transition:width .6s ease}.fb-bar-in.ok{background:var(--plk-success,#2f9e5f)}.fb-bar-in.bad{background:var(--plk-danger,#d64541)}
.fb-card-fail h2{color:var(--plk-danger,#b42318)}
.fb-prog-hero.row{display:flex;align-items:center;gap:18px;text-align:left;padding:4px 0 16px}
.fb-prog-hero.row .fb-ring{margin:0;width:72px;height:72px;flex:none}.fb-prog-hero.row .fb-ring-in{width:56px;height:56px}.fb-prog-hero.row .fb-pct{font-size:15px}
.fb-prog.wide .wa-ribbon{margin-bottom:16px}
.fb-mx th,.fb-mx td{white-space:nowrap}.fb-mx td.m{font-weight:600}
.fb-fail{display:flex;gap:10px;padding:10px 0;border-top:1px solid var(--plk-border,#e7e2dc)}.fb-fail:first-child{border-top:none;padding-top:0}
.fb-fail b{font-size:13px;color:var(--plk-text,#1c1b22)}.fb-fail .why{font-size:12px;color:var(--plk-danger,#b42318);margin-top:2px;line-height:1.45}.fb-fail .why b{color:var(--plk-danger,#b42318);font-size:12px}
.fb-expect{margin-top:14px}.fb-expect-row{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px}
.fb-expect .big{font-size:22px;font-weight:800;font-family:ui-monospace,Menlo,monospace;color:var(--plk-text,#1c1b22)}
@media(max-width:700px){.fb-expect-row{grid-template-columns:1fr}}
.fb-pi{width:26px;height:26px;border-radius:50%;display:grid;place-items:center;flex:none}
.fb-pi.ok{background:var(--plk-success-soft,#e3f5ea)}
.fb-pi.ok .material-icons{font-size:17px;color:var(--plk-success,#2f9e5f)}
.fb-pi.err{background:var(--plk-danger-soft,#fbe6e5)}
.fb-pi.err .material-icons{font-size:17px;color:var(--plk-danger,#b42318)}
`;
if (typeof document !== "undefined") {
  let el = document.getElementById("fb-styles");
  if (!el) {
    el = document.createElement("style");
    el.id = "fb-styles";
    document.head.appendChild(el);
  }
  el.textContent = CSS;
}

// Placements per channel — one slot object per image/video the channel needs.
// slotKey MUST match Service.AdCampaign FlightPlanner.SlotManifest exactly; the
// backend validates each upload against that slot's aspect ratio + min size and
// stores it at a public S3 URL the providers fetch. Each channel keeps its OWN
// creative bucket (Display ≠ Retarget), so both can run different images.
//   ratio    target aspect (w/h) — steers guidance + set-suffix pairing
//   kind     "" image · "youtube" paste a public link · "video" MP4/MOV upload
//   optional slot can be left empty
//   shared   one per whole ad, not per creative set (logo / video / link)
const PLACEMENTS = {
  Display: [{
    name: "Landscape",
    dims: "1.91:1 — 1000×525 or 1200×628",
    slotKey: "landscape_1200x628",
    ratio: 1200 / 628
  }, {
    name: "Square",
    dims: "1:1 — 525×525 or 1200×1200",
    slotKey: "square_1200x1200",
    ratio: 1
  }, {
    name: "Logo",
    dims: "1:1 — 512×512 · optional",
    slotKey: "logo_512x512",
    ratio: 1,
    optional: true,
    shared: true
  }],
  Retarget: [{
    name: "Landscape",
    dims: "1.91:1 — 1000×525 or 1200×628",
    slotKey: "landscape_1200x628",
    ratio: 1200 / 628
  }, {
    name: "Square",
    dims: "1:1 — 525×525 or 1200×1200",
    slotKey: "square_1200x1200",
    ratio: 1
  }, {
    name: "Logo",
    dims: "1:1 — 512×512 · optional",
    slotKey: "logo_512x512",
    ratio: 1,
    optional: true,
    shared: true
  }],
  Social: [{
    name: "Square",
    dims: "1:1 — 1800×1800",
    slotKey: "social_1800x1800_1",
    ratio: 1
  }],
  Search: [],
  // keyword + copy panel, no image slots
  // YouTube + CTV share the backend's youtube_link slot (a public video link,
  // not an upload); placements() collapses them into one row when both run.
  YouTube: [{
    name: "YouTube video",
    dims: "Public video link",
    slotKey: "youtube_link",
    kind: "youtube",
    shared: true
  }],
  CTV: [{
    name: "CTV / OTT video",
    dims: "Public video link",
    slotKey: "youtube_link",
    kind: "youtube",
    shared: true
  }],
  SocialVideo: [{
    name: "Primary video",
    dims: "16:9 or 1:1 — ≤60s MP4/MOV",
    slotKey: "video_primary",
    kind: "video",
    shared: true
  }, {
    name: "Vertical video",
    dims: "9:16 — Reels/Stories · optional",
    slotKey: "video_vertical_9x16",
    kind: "video",
    optional: true,
    shared: true
  }]
};

// Pull a YouTube video id out of any watch/short/embed/youtu.be link, then
// build the auto-generated thumbnail URL YouTube serves for it (no API key).
// hqdefault always exists; maxresdefault is missing on some videos, so we
// use hq for a reliable render.
function ytId(link) {
  const s = String(link || "");
  const m = s.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/i);
  return m ? m[1] : "";
}
function ytThumb(link) {
  const id = ytId(link);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}
const SEGS = [["In-market", [["Home & Garden › Furniture", "Google · in-market", "2.1M", "furniture home"], ["Luxury Home Goods Shoppers", "Meta · in-market", "880K", "luxury home"], ["Interior Design Services", "Google · in-market", "540K", "interior design"]]], ["Affinity & interests", [["Interior Design Enthusiasts", "Google · affinity", "3.4M", "interior design"], ["Luxury Lifestyle", "Meta · interest", "5.2M", "luxury"], ["Home Décor & Renovation", "Meta · interest", "4.1M", "home decor renovation"], ["Design & Architecture Fans", "Google · affinity", "2.8M", "design architecture"]]], ["Detailed demographics", [["Homeowners, $150k+ HH income", "Meta · demographic", "1.6M", "homeowner income"], ["Recently Moved", "Google · life event", "920K", "moved"]]]];

/** A text box that wraps and grows with its text, so long ad copy is never cut off (2026-10-16). `single` drops line breaks. */
class GrowText extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "fit", el => {
      if (el) {
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight + 2}px`;
      }
    });
  }
  componentDidMount() {
    this.fit(this._el);
  }
  componentDidUpdate() {
    this.fit(this._el);
  }
  render() {
    const {
      value,
      onChange,
      single,
      minLines,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement("textarea", _extends({
      ref: el => {
        this._el = el;
      },
      className: "fb-input",
      rows: 1,
      value: value || ""
    }, rest, {
      style: {
        resize: "none",
        overflow: "hidden",
        lineHeight: 1.4,
        paddingTop: 8,
        paddingBottom: 8,
        height: "auto",
        minHeight: this.props.minLines ? 16 + 20 * this.props.minLines : 38,
        whiteSpace: "pre-wrap"
      },
      onKeyDown: single ? e => {
        if (e.key === "Enter") e.preventDefault();
      } : undefined,
      onChange: e => onChange(single ? e.target.value.replace(/[\r\n]+/g, " ") : e.target.value)
    }));
  }
}
class FlightBuilderView extends React.Component {
  constructor(_p) {
    super(_p);
    // The Content Hub picture into every empty image slot of set A, cropped to each slot's shape at its size (the
    // backend checks shape and minimum size per slot). A picture the browser can't read (no CORS) stays in the library.
    _defineProperty(this, "fillPrefillImage", async () => {
      const url = this.state.prefillImage;
      if (!url) return;
      this.setState({
        prefillBusy: true,
        note: null
      });
      let img;
      try {
        // cache "reload": the page already showed this picture through an <img>, and that cached copy can't be reused for a
        // cross-origin read (Chrome fails the fetch); a fresh request carries the bucket's CORS headers.
        const blob = await (await fetch(url, {
          mode: "cors",
          cache: "reload"
        })).blob();
        img = await new Promise((res, rej) => {
          const i = new Image();
          i.onload = () => res(i);
          i.onerror = rej;
          i.src = URL.createObjectURL(blob);
        });
      } catch (e) {
        this.setState({
          prefillBusy: false,
          note: "Couldn't read the Content Hub picture here: upload it into the slots below."
        });
        return;
      }
      const size = k => {
        const m = /(\d+)x(\d+)/.exec(k || "");
        return m ? [Number(m[1]), Number(m[2])] : [1200, 1200];
      };
      const slots = this.placementsFor(0).filter(p => p.ratio && !p.optional && !p.kind && !(this.state.groups[0].slots || {})[p.key]);
      let done = 0;
      for (const p of slots) {
        const [w, h] = size(p.slotKey);
        const c = document.createElement("canvas");
        c.width = w;
        c.height = h;
        const sr = img.width / img.height,
          tr = w / h;
        const sw = sr > tr ? img.height * tr : img.width,
          sh = sr > tr ? img.height : img.width / tr;
        c.getContext("2d").drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, 0, 0, w, h);
        const file = await new Promise(res => c.toBlob(b => res(b ? new File([b], `content-hub-${p.slotKey}.jpg`, {
          type: "image/jpeg"
        }) : null), "image/jpeg", 0.92));
        if (file) {
          await this.uploadSlot(0, p, file);
          done++;
        }
      }
      this.setState({
        prefillBusy: false,
        prefillImage: done ? null : this.state.prefillImage,
        note: done ? `The Content Hub picture is in ${done} slot${done === 1 ? "" : "s"}, cropped to each shape. Check the crops below.` : "Every image slot already has a picture."
      });
    });
    _defineProperty(this, "applyEdit", async () => {
      if (!this.state.editId) return;
      this.setState({
        applying: true,
        note: null
      });
      try {
        await this.saveMetaPages();
        await adSvc(`/flights/${this.state.editId}/apply`).putAsync(this.buildRequest());
        // Save changes (edit only) lands the user on the fresh flight detail page —
        // it shows the live campaigns updating and any newly-launched channel — rather
        // than an intermediate summary that can go stale. New-flight launch keeps its
        // own progress flow.
        this.props.history.push(`/Campaigns/flight/${this.state.editId}`);
      } catch (e) {
        this.setState({
          applying: false,
          note: this.errText(e, "Couldn't save changes — try again.")
        });
      }
    });
    _defineProperty(this, "saveDraftEdit", async () => {
      if (!this.state.editId) return;
      this.setState({
        busy: true,
        note: null
      });
      try {
        await adSvc(`/flights/${this.state.editId}`).putAsync(this.buildRequest());
        this.setState({
          busy: false,
          draft: {
            id: this.state.editId
          }
        });
      } catch (e) {
        this.setState({
          busy: false,
          note: this.errText(e, "Couldn't save the draft.")
        });
      }
    });
    // Persist the current demographics as the tenant's saved profile (the default
    // every new flight is seeded from). Independent of this flight's own targeting.
    _defineProperty(this, "saveProfile", async () => {
      this.setState({
        savingProfile: true,
        profileSaved: false
      });
      try {
        await adSvc("/demographics").putAsync(this.state.demographics);
        this.setState({
          savingProfile: false,
          profileSaved: true
        });
      } catch (e) {
        this.setState({
          savingProfile: false,
          note: this.errText(e, "Couldn't save the targeting profile.")
        });
      }
    });
    _defineProperty(this, "createDraft", async () => {
      if (!this.canDraft()) return this.state.draft || null;
      this.setState({
        busy: true,
        note: null
      });
      try {
        // Always persist the CURRENT state. An existing draft/edit is updated
        // in place (PUT) so budget/market/schedule edits made after the draft
        // was first saved reach the backend before validate/submit — without
        // this, the first-saved values (e.g. the default budget) were sent.
        // A brand-new flight POSTs a fresh draft.
        const existingId = this.state.editId || this.state.draft && this.state.draft.id;
        if (existingId) {
          await adSvc(`/flights/${existingId}`).putAsync(this.buildRequest());
          const d = {
            id: existingId
          };
          this.setState({
            draft: d,
            busy: false
          });
          return d;
        }
        const d = await adSvc("/flights").postAsync(this.buildRequest());
        this.setState({
          draft: d,
          busy: false
        });
        return d;
      } catch (e) {
        this.setState({
          busy: false,
          note: this.errText(e, "Could not save the draft.")
        });
        return null;
      }
    });
    // Upload ONE image straight into its slot. The backend validates aspect ratio
    // + minimum size for that exact slot and rejects a mismatch, so each slot
    // takes its own correctly-shaped image — no client-side cropping. On success
    // the creative row is stored with a public S3 URL the providers ingest.
    _defineProperty(this, "uploadSlot", async (gi, p, file) => {
      if (!file) return;
      const key = `${gi}:${p.key}`;
      this.setState(st => ({
        uploadingSlot: key,
        slotErr: {
          ...st.slotErr,
          [key]: null
        }
      }));
      const d = await this.ensureDraft().catch(() => null);
      if (!d) {
        this.setState({
          uploadingSlot: null
        });
        this.setSlotErr(key, "Finish the Flight basics step first — the draft has to exist before creative can upload.");
        return;
      }
      try {
        const {
          AuthBase
        } = await import("../../../plunk/service/auth-base");
        const fd = new FormData();
        fd.append("file", file);
        fd.append("channel", p.channel);
        fd.append("slotKey", this.slotKeyFor(gi, p));
        fd.append("tier", "shared");
        const res = await fetch(`${endpoints.product.root}/campaign/ad/flights/${d.id}/creative`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${AuthBase.idToken || ""}`,
            "x-app-id": (account.get() || {}).tenantId
          },
          body: fd
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) {
          this.setState({
            uploadingSlot: null
          });
          this.setSlotErr(key, body.error || "Upload failed — check the image size and shape.");
          return;
        }
        const aid = body.id || `a${Date.now()}`;
        let preview = "";
        try {
          preview = URL.createObjectURL(file);
        } catch (x) {}
        const asset = {
          id: aid,
          name: (file.name || "image").replace(/\.[^.]+$/, ""),
          url: body.url || preview,
          w: body.width,
          h: body.height
        };
        const groups = this.state.groups.slice();
        const g = {
          ...groups[gi],
          slots: {
            ...groups[gi].slots
          }
        };
        g.slots[p.key] = aid;
        groups[gi] = g;
        this.setState(st => ({
          assets: st.assets.concat(asset),
          groups,
          uploadingSlot: null
        }));
      } catch (e) {
        this.setState({
          uploadingSlot: null
        });
        this.setSlotErr(key, "Upload failed — try again.");
      }
    });
    // MP4/MOV video slots exceed the API-gateway 10MB cap, so they ride a
    // presigned S3 PUT: (1) get a 15-min upload URL, (2) PUT straight to S3,
    // (3) register the object (verifies size/type, records the hosted URL).
    _defineProperty(this, "uploadVideo", async (gi, p, file) => {
      if (!file) return;
      const key = `${gi}:${p.key}`;
      const ct = (file.type || "").toLowerCase() === "video/quicktime" ? "video/quicktime" : "video/mp4";
      this.setState(st => ({
        uploadingSlot: key,
        slotErr: {
          ...st.slotErr,
          [key]: null
        }
      }));
      const d = await this.ensureDraft().catch(() => null);
      if (!d) {
        this.setState({
          uploadingSlot: null
        });
        this.setSlotErr(key, "Finish the Flight basics step first.");
        return;
      }
      try {
        const up = await adSvc(`/flights/${d.id}/creative/video-upload-url`).postAsync({
          channel: "SocialVideo",
          slotKey: p.slotKey,
          contentType: ct
        });
        const putRes = await fetch(up.uploadUrl || up.UploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": ct
          },
          body: file
        });
        if (!putRes.ok) throw new Error("s3");
        const reg = await adSvc(`/flights/${d.id}/creative/video-register`).postAsync({
          slotKey: p.slotKey,
          key: up.key || up.Key
        });
        const aid = reg && (reg.id || reg.Id) || `vid${Date.now()}`;
        let preview = "";
        try {
          preview = URL.createObjectURL(file);
        } catch (x) {}
        const asset = {
          id: aid,
          name: (file.name || "video").replace(/\.[^.]+$/, ""),
          url: preview,
          videoFile: true,
          link: reg && (reg.url || reg.Url) || ""
        };
        const groups = this.state.groups.slice();
        const g = {
          ...groups[gi],
          slots: {
            ...groups[gi].slots
          }
        };
        g.slots[p.key] = aid;
        groups[gi] = g;
        this.setState(st => ({
          assets: st.assets.concat(asset),
          groups,
          uploadingSlot: null
        }));
      } catch (e) {
        this.setState({
          uploadingSlot: null
        });
        this.setSlotErr(key, this.errText(e, "Video upload failed — MP4/MOV up to 500MB."));
      }
    });
    // Persist a public YouTube/CTV link. The backend extracts the video id and
    // drives the fan-out; we render its auto-generated thumbnail. The one link
    // feeds every rail it serves (YouTube and/or CTV), so post it to each.
    _defineProperty(this, "addVideoLink", async gi => {
      const url = String(this.state.videoUrl || "").trim();
      if (!ytId(url)) {
        this.setState({
          videoErr: "That doesn't look like a YouTube link — paste a watch, share, or Shorts URL."
        });
        return;
      }
      this.setState({
        videoBusy: true,
        videoErr: null
      });
      const ytRow = this.placements().find(p => p.kind === "youtube");
      const channels = ytRow && ytRow.videoChannels || ["YouTube"];
      const aid = `v${Date.now()}_${Math.random().toString(36).slice(2, 5)}`;
      const asset = {
        id: aid,
        name: "YouTube video",
        url: ytThumb(url),
        link: url,
        video: true
      };
      // The link is shared for the whole flight — assign it to set A.
      const groups = this.state.groups.slice();
      const g = {
        ...groups[0],
        slots: {
          ...groups[0].slots
        }
      };
      if (ytRow) g.slots[ytRow.key] = aid;
      groups[0] = g;
      this.setState(st => ({
        assets: st.assets.concat(asset),
        groups,
        libOpen: false,
        videoBusy: false,
        videoUrl: ""
      }));
      try {
        const d = await this.ensureDraft();
        if (d) for (let i = 0; i < channels.length; i++) await adSvc(`/flights/${d.id}/creative/youtube`).postAsync({
          url,
          channel: channels[i]
        });
      } catch (e) {/* local preview stands; persists again on submit/apply */}
    });
    // ── keywords (Search) ──
    _defineProperty(this, "addKeywords", raw => {
      const parts = String(raw || "").split(/[\n,]+/).map(k => k.trim().replace(/^["']|["']$/g, "")).filter(Boolean);
      if (!parts.length) return;
      this.setState(st => {
        const seen = {};
        const merged = [];
        st.keywords.concat(parts).forEach(k => {
          const lc = k.toLowerCase();
          if (!seen[lc]) {
            seen[lc] = 1;
            merged.push(k);
          }
        });
        return {
          keywords: merged,
          keywordInput: ""
        };
      });
    });
    _defineProperty(this, "rmKeyword", k => this.setState(st => ({
      keywords: st.keywords.filter(x => x !== k)
    })));
    // Persist the Meta page ids before validate/submit/apply so the server-side
    // check sees them (Social/SocialVideo only; account-level, reused per flight).
    _defineProperty(this, "saveMetaPages", async () => {
      if (!this.state.channels.Social && !this.state.channels.SocialVideo) return;
      try {
        await adSvc("/meta-pages").putAsync({
          pageId: (this.state.metaPageId || "").trim(),
          instagramId: (this.state.metaInstagramId || "").trim()
        });
      } catch (e) {/* validate surfaces a missing page */}
    });
    _defineProperty(this, "validate", async () => {
      const d = await this.createDraft();
      if (!d) return;
      this.setState({
        validating: true,
        note: null
      });
      try {
        await this.saveMetaPages();
        const report = await adSvc(`/flights/${d.id}/validate`).postAsync({});
        this.setState({
          report,
          validating: false
        });
      } catch (e) {
        this.setState({
          validating: false,
          note: "Validation failed — try again."
        });
      }
    });
    _defineProperty(this, "submit", async () => {
      const d = await this.createDraft();
      if (!d) return;
      this.setState({
        submitting: true,
        note: null
      });
      try {
        await this.saveMetaPages();
        await adSvc(`/flights/${d.id}/submit`).postAsync({});
        this.setState({
          submitting: false
        });
        this.props.history.push(`/Campaigns/flight/${d.id}`);
      } catch (e) {
        let r = null;
        try {
          r = JSON.parse(e.message);
        } catch (x) {}
        if (r && (r.flightErrors || r.cells)) this.setState({
          report: r,
          submitting: false
        });else this.setState({
          submitting: false,
          note: this.errText(e, "Submit failed — run Validate for details.")
        });
      }
    });
    this.state = {
      ready: false,
      error: false,
      step: 0,
      eventName: "",
      landingPage: "",
      channels: {
        Display: true,
        Retarget: true,
        Social: true
      },
      markets: null,
      sameBudget: true,
      sharedBudget: 6,
      pacing: "Standard (even)",
      cap: "50% (recommended)",
      schedule: {
        startImmediately: true,
        noEndDate: true,
        startDate: "",
        endDate: ""
      },
      segQ: "",
      segRows: null,
      segCat: "All",
      segProv: "All",
      segErr: null,
      inc: [],
      excl: [],
      tiers: [],
      audOpen: false,
      tenantAuds: null,
      audErr: null,
      audPending: {},
      audDone: {},
      fwdOff: false,
      llRatio: 1,
      llBusy: {},
      draft: null,
      uploadingSlot: null,
      slotErr: {},
      // Meta page ids (Social / Social Video run under the tenant's Facebook
      // Page; Instagram optional). Account-level — saved via /meta-pages.
      metaPageId: "",
      metaInstagramId: "",
      assets: [],
      groups: [{
        name: "Creative set A",
        slots: {}
      }],
      // Ad copy drives responsive display / social / video ad text; Search
      // needs its own headlines + a keyword list (CSV paste or manual).
      adCopy: {
        headline: "",
        longHeadline: "",
        description: "",
        businessName: "",
        message: ""
      },
      keywords: [],
      keywordInput: "",
      libOpen: false,
      libTab: "all",
      libSel: [],
      libGroup: 0,
      report: null,
      validating: false,
      submitting: false,
      flight: null,
      cells: null,
      busy: false,
      note: null,
      editId: null,
      flightStatus: null,
      applying: false,
      // Age/gender targeting (editable in the Audiences step). YouTube + CTV
      // (Google video) REQUIRE age ranges, so seed a sensible all-adults
      // default; init() overrides it with the tenant's saved
      // ad_demographic_profile when one is configured.
      demographics: {
        ageRanges: ["25-34", "35-44", "45-54", "55-64", "65+"],
        gender: ["All"],
        householdIncomes: [],
        languages: []
      }
    };
    this._alive = true;
  }
  componentDidMount() {
    this.init();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._poll);
    clearTimeout(this._segT);
    clearTimeout(this._audPoll);
  }
  async init() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    // Pull the tenant's saved demographic profile; keep the all-adults
    // default when none is configured so YouTube/CTV flights still validate.
    adSvc("/demographics").getAsync().then(d => {
      if (!this._alive || !d) return;
      // Editing a flight? Its own saved demographics win over the tenant
      // default — don't let this async profile load clobber them.
      if (this.state.editId) return;
      const ar = d.ageRanges || d.AgeRanges;
      if (ar && ar.length) this.setState({
        demographics: {
          ageRanges: ar,
          gender: d.gender || d.Gender || ["All"],
          householdIncomes: d.householdIncomes || d.HouseholdIncomes || [],
          languages: d.languages || d.Languages || []
        }
      });
    }).catch(() => {/* keep the default */});
    // Meta page ids (Social channels run under the tenant's Facebook Page).
    adSvc("/meta-pages").getAsync().then(d => this._alive && this.setState({
      metaPageId: d && (d.pageId || d.PageId) || "",
      metaInstagramId: d && (d.instagramId || d.InstagramId) || ""
    })).catch(() => {/* not configured yet */});
    try {
      const places = await locSvc("/location/places").getAsync();
      if (!this._alive) return;
      const markets = (Array.isArray(places) ? places : []).map(m => {
        const name = m.name || m.Name;
        const zips = (m.zips || m.Zips || m.geoTargetPostalCodes || []).map(String);
        let lat = m.lat != null ? m.lat : m.latitude != null ? m.latitude : m.centroidLat != null ? m.centroidLat : null;
        let lng = m.lng != null ? m.lng : m.longitude != null ? m.longitude : m.centroidLng != null ? m.centroidLng : null;
        if (lat == null || lng == null) {
          const g = centroidFromZips(zips) || geocodeMarket(name);
          if (g) {
            lat = g[0];
            lng = g[1];
          }
        }
        return {
          name,
          zips,
          lat,
          lng,
          include: false,
          dailyBudget: 6
        };
      }).filter(m => m.name);
      const editId = (this.props.params || {}).id || null;
      if (editId) {
        const f = await adSvc(`/flights/${editId}`).getAsync().catch(() => null);
        if (this._alive && f) {
          this.hydrate(markets, f);
          return;
        }
      }
      this.setState({
        markets,
        ready: true
      }, () => {
        this.applyContentPrefill();
        this.applyAudiencePrefill();
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }

  // Pre-fill the builder from an existing flight (draft or live) for editing.
  hydrate(markets, f) {
    const req = f.request || f.Request || {};
    const chans = {};
    (req.channels || req.Channels || []).forEach(c => {
      chans[c] = true;
    });
    const reqMkts = req.markets || req.Markets || [];
    const byName = {};
    reqMkts.forEach(m => {
      byName[String(m.name || m.Name || "").toLowerCase()] = m;
    });
    const hydMarkets = markets.map(m => {
      const rm = byName[m.name.toLowerCase()];
      if (!rm) return m;
      const zips = (rm.locations || rm.Locations || m.zips).map(String);
      return {
        ...m,
        include: true,
        zips,
        dailyBudget: Number(rm.dailyBudget || rm.DailyBudget) || m.dailyBudget
      };
    });
    const budgets = reqMkts.map(m => Number(m.dailyBudget || m.DailyBudget) || 0).filter(b => b > 0);
    const sameBudget = budgets.length <= 1 || budgets.every(b => b === budgets[0]);
    const inc = (req.catalogAudiences || req.CatalogAudiences || []).map(a => ({
      name: a.name || a.Name,
      id: a.id || a.Id || null,
      provider: a.provider || a.Provider || null,
      kind: a.kind || a.Kind || null
    })).filter(a => a.name);
    // Custom-audience cells only (segments are the implicit base); drop any
    // stored "Core" tier.
    const tiers = (req.tiers || req.Tiers || []).filter(t => String(t.name || t.Name || "").toLowerCase() !== "core").map(t => ({
      name: t.name || t.Name,
      meta: (t.customAudiences || t.CustomAudiences || [])[0] || null,
      google: t.googleUserList || t.GoogleUserList || null
    })).filter(t => t.meta || t.google);
    const sc = req.schedule || req.Schedule || {};
    // Restore ad copy, keywords, and the flight's OWN demographics so an edit
    // shows what was saved (init's profile load is guarded to not clobber
    // these when editId is set — the flight's targeting wins over the tenant
    // default).
    const ac = req.adCopy || req.AdCopy || {};
    const adCopy = {
      headline: ac.headline || ac.Headline || "",
      longHeadline: ac.longHeadline || ac.LongHeadline || "",
      description: ac.description || ac.Description || "",
      businessName: ac.businessName || ac.BusinessName || "",
      message: ac.message || ac.Message || ""
    };
    const sa = (req.searchAds || req.SearchAds || [])[0] || {};
    const keywords = (sa.keywords || sa.Keywords || []).map(k => k.value || k.Value).filter(Boolean);
    const dem = req.demographics || req.Demographics || null;
    const demographics = dem ? {
      ageRanges: dem.ageRanges || dem.AgeRanges || [],
      gender: dem.gender || dem.Gender || ["All"],
      householdIncomes: dem.householdIncomes || dem.HouseholdIncomes || [],
      languages: dem.languages || dem.Languages || []
    } : this.state.demographics;
    this.setState({
      markets: hydMarkets,
      ready: true,
      editId: f.id || f.Id || (this.props.params || {}).id,
      flightStatus: f.status || f.Status || "",
      eventName: req.eventName || f.eventName || f.Name || "",
      landingPage: req.landingPage || f.landingPage || f.LandingPage || "",
      channels: Object.keys(chans).length ? chans : this.state.channels,
      sameBudget,
      sharedBudget: budgets[0] || this.state.sharedBudget,
      inc,
      tiers,
      adCopy,
      keywords,
      demographics,
      schedule: {
        startImmediately: sc.startImmediately !== false,
        noEndDate: sc.noEndDate !== false,
        startDate: sc.startDate || "",
        endDate: sc.endDate || ""
      }
    });
    // The flight GET returns the full creative list (every set + slot key,
    // ids stringified) — hydrate straight from it. It's authoritative and
    // includes extra sets (__N); the /manifest endpoint only enumerates base
    // slots, so it dropped sets B/C (and wasn't restoring reliably). Fall
    // back to the manifest fetch only when the flight didn't carry creative.
    const creativeList = f.creative || f.Creative;
    if (Array.isArray(creativeList) && creativeList.length) this.hydrateCreativeFromList(creativeList);else this.hydrateCreative(f.id || f.Id || (this.props.params || {}).id);
  }
  // Build the creative sets from the flight's own creative rows
  // ({channel, tier, slotKey, url}). Extra sets suffix the slot key __N.
  hydrateCreativeFromList(list) {
    const assets = [];
    const bySet = {};
    const setOf = sk => {
      const m = String(sk || "").match(/__(\d{1,2})$/);
      return m ? parseInt(m[1], 10) - 1 : 0;
    };
    list.forEach(c => {
      const channel = c.channel || c.Channel;
      const url = c.url || c.Url;
      if (!url) return;
      const rawKey = String(c.slotKey || c.SlotKey || "");
      const baseKey = rawKey.replace(/__(\d{1,2})$/, "");
      const isYt = baseKey === "youtube_link";
      const gi = isYt || /^(logo_|video_)/.test(baseKey) ? 0 : setOf(rawKey);
      const compositeKey = isYt ? "video::youtube_link" : channel + "::" + baseKey;
      if (!bySet[gi]) bySet[gi] = {};
      if (bySet[gi][compositeKey]) return;
      const isImg = /^https?:\/\/\S+\.(png|jpe?g|gif|webp)(\?|#|$)/i.test(url);
      const thumb = ytThumb(url);
      const isVideoFile = /\.(mp4|mov)(\?|#|$)/i.test(url);
      const aid = `m${assets.length}_${Math.random().toString(36).slice(2, 5)}`;
      assets.push({
        id: aid,
        name: isImg ? baseKey : thumb ? "YouTube video ✓" : "Video ✓",
        url: isImg ? url : thumb,
        link: url,
        video: !!thumb,
        videoFile: isVideoFile,
        existing: true
      });
      bySet[gi][compositeKey] = aid;
    });
    const idxs = Object.keys(bySet).map(Number).sort((a, b) => a - b);
    if (assets.length) {
      // Pack sets consecutively (A, B, C…) by position, not original index.
      const groups = idxs.map((origGi, i) => ({
        name: `Creative set ${String.fromCharCode(65 + i)}`,
        slots: bySet[origGi]
      }));
      this.setState({
        assets,
        groups
      });
    }
  }
  // Pre-fill the Creative step from the flight's existing assets (manifest),
  // so an edit shows what's already running rather than empty slots.
  hydrateCreative(id) {
    if (!id) return;
    adSvc(`/flights/${id}/manifest`).getAsync().then(d => {
      if (!this._alive) return;
      const manifest = d && d.manifest || d && d.Manifest || [];
      const assets = [];
      const bySet = {}; // setIndex(0-based) -> slots map
      const setOf = sk => {
        const m = String(sk || "").match(/__(\d{1,2})$/);
        return m ? parseInt(m[1], 10) - 1 : 0;
      };
      manifest.forEach(ch => {
        const channel = ch.channel || ch.Channel;
        if (!(PLACEMENTS[channel] || []).length) return;
        (ch.slots || ch.Slots || []).forEach(sl => {
          const uploaded = sl.uploaded || sl.Uploaded || {};
          const val = sl.url || sl.Url || sl.imageUrl || uploaded.shared || Object.values(uploaded).find(Boolean);
          if (!val) return;
          const rawKey = String(sl.slotKey || sl.SlotKey || "");
          const baseKey = rawKey.replace(/__(\d{1,2})$/, "");
          const isYt = baseKey === "youtube_link";
          const gi = isYt || /^(logo_|video_)/.test(baseKey) ? 0 : setOf(rawKey);
          const compositeKey = isYt ? "video::youtube_link" : channel + "::" + baseKey;
          if (!bySet[gi]) bySet[gi] = {};
          if (bySet[gi][compositeKey]) return;
          const isImg = /^https?:\/\/\S+\.(png|jpe?g|gif|webp)(\?|#|$)/i.test(String(val));
          const thumb = ytThumb(val);
          const isVideoFile = /\.(mp4|mov)(\?|#|$)/i.test(String(val));
          const aid = `m${assets.length}_${Math.random().toString(36).slice(2, 5)}`;
          assets.push({
            id: aid,
            name: isImg ? sl.label || sl.Label || baseKey : thumb ? "YouTube video ✓" : "Video ✓",
            url: isImg ? val : thumb,
            link: val,
            video: !!thumb,
            videoFile: isVideoFile,
            existing: true
          });
          bySet[gi][compositeKey] = aid;
        });
      });
      const idxs = Object.keys(bySet).map(Number).sort((a, b) => a - b);
      if (assets.length) {
        const groups = idxs.map(gi => ({
          name: `Creative set ${String.fromCharCode(65 + gi)}`,
          slots: bySet[gi]
        }));
        this.setState({
          assets,
          groups: groups.length ? groups : [{
            name: "Creative set A",
            slots: {}
          }]
        });
      }
    }).catch(() => {/* no manifest / not yet created — leave slots empty */});
  }
  // Content Hub › Make › Ad piece › "Send to a flight" (2026-10-02): headline, description and media arrive via sessionStorage.
  // ?audience={id}&name= from an Audiences list ("Show ads to these people"): open the Audiences step with that
  // list added when it is ready for ads, or with the picker open so it can be built for ads first.
  applyAudiencePrefill() {
    const q = new URLSearchParams(window.location.search);
    const id = q.get("audience");
    if (!id) return;
    const name = q.get("name") || "";
    const step = STEPS.findIndex(x => x[0] === "Audiences");
    this.loadAuds().then(() => {
      if (!this._alive) return;
      const a = (this.state.tenantAuds || []).find(x => String(x.id) === id || name && x.name === name);
      if (step >= 0) this.go(step);
      if (a && (a.metaAudienceId || a.googleUserList)) this.addAudTier(a);else this.setState({
        audOpen: true
      });
    });
  }
  applyContentPrefill() {
    let pre = null;
    try {
      const raw = sessionStorage.getItem("plunk-flight-prefill");
      if (raw) {
        pre = JSON.parse(raw);
        sessionStorage.removeItem("plunk-flight-prefill");
      }
    } catch (e) {
      pre = null;
    }
    if (!pre || pre.from !== "content") return;
    // Fit each field to its limit at a sentence, then a word, break; never mid-word (2026-10-16).
    const fit = (t, n) => {
      const x = String(t || "").replace(/\s+/g, " ").trim();
      if (x.length <= n) return x;
      const cut = x.slice(0, n + 1);
      const sent = Math.max(cut.lastIndexOf(". "), cut.lastIndexOf("! "), cut.lastIndexOf("? "));
      if (sent >= 20) return cut.slice(0, sent + 1).trim();
      const comma = cut.lastIndexOf(", ");
      if (comma >= n * 0.5) return cut.slice(0, comma).trim() + ".";
      // never end on a dangling little word ("Fresh Content in Under a")
      const sp = cut.lastIndexOf(" ");
      let out = (sp > 0 ? cut.slice(0, sp) : x.slice(0, n)).replace(/[\s,;:–—-]+$/, "").trim();
      for (let k = 0; k < 3; k++) {
        const m = /\s+(a|an|the|of|in|to|for|and|or|with|on|at|by|your|our|from|under|into)$/i.exec(out);
        if (!m || out.length - m[0].length < 12) break;
        out = out.slice(0, m.index).replace(/[\s,;:–—-]+$/, "");
      }
      return out;
    };
    const full = String(pre.body || pre.description || "").trim();
    const sentences = full.split(/(?<=[.!?])\s+/).filter(Boolean);
    const c0 = this.state.adCopy;
    const adCopy = {
      ...c0,
      headline: fit(pre.headline, 30) || c0.headline,
      longHeadline: c0.longHeadline || fit(sentences[0] || pre.headline || "", 90),
      // the description picks up after the sentence the long headline already says
      description: fit(sentences.slice(sentences.length > 1 ? 1 : 0).join(" ") || full, 90) || c0.description,
      message: c0.message || fit(full, 500)
    };
    const assets = this.state.assets.slice();
    if (pre.imageUrl) assets.push({
      id: `c${Date.now()}`,
      name: "From the Content Hub",
      url: pre.imageUrl
    });else if (pre.videoUrl) assets.push({
      id: `c${Date.now()}`,
      name: "From the Content Hub",
      url: pre.videoUrl,
      videoFile: true,
      link: pre.videoUrl
    });
    // The flight's name and landing page come from the story (DS 2026-10-21: the title was left empty); never over
    // what is already typed. The picture is offered for every image slot below (prefillImage).
    const s0 = this.state;
    this.setState({
      adCopy,
      assets,
      eventName: s0.eventName || String(pre.eventName || "").slice(0, 120),
      landingPage: s0.landingPage || String(pre.landingPage || ""),
      prefillImage: pre.imageUrl || null,
      note: `Filled from the Content Hub ad piece: the flight name, headline, description${pre.landingPage ? ", landing page" : ""} and the ${pre.imageUrl ? "picture" : "creative"} are in. Pick markets and a budget${pre.imageUrl ? ", then fill the image slots with the picture" : ""}.`
    });
  }
  isLiveFlight() {
    return this.state.editId && !["draft"].includes(String(this.state.flightStatus || "").toLowerCase());
  }
  go(i) {
    this.setState({
      step: i,
      note: null
    });
  }
  togCh(c) {
    const ch = {
      ...this.state.channels
    };
    ch[c] = !ch[c];
    if (!ch[c]) delete ch[c];
    this.setState({
      channels: ch
    });
  }
  togMkt(i) {
    const m = this.state.markets.slice();
    m[i] = {
      ...m[i],
      include: !m[i].include
    };
    this.setState({
      markets: m
    });
  }
  selChannels() {
    return Object.keys(this.state.channels).filter(c => this.state.channels[c]);
  }
  selMarkets() {
    return (this.state.markets || []).filter(m => m.include);
  }
  // What the flight adds up to from the form as it stands. Campaigns = markets x
  // channels x audience sets; the per-day figure sums every campaign's quoted daily
  // budget (the number the client is quoted, before Plunk's server-side padding).
  expectedSpend() {
    const s = this.state;
    const chans = this.selChannels().length;
    const sets = s.tiers.length === 0 ? 1 : s.tiers.length + 1;
    const per = chans * sets;
    const mkts = this.selMarkets();
    const daily = mkts.reduce((sum, m) => sum + Math.max(0, Math.round(Number(s.sameBudget ? s.sharedBudget : m.dailyBudget) || 0)) * per, 0);
    const start = s.schedule.startImmediately || !s.schedule.startDate ? new Date() : new Date(s.schedule.startDate);
    let days = 30,
      through;
    if (!s.schedule.noEndDate && s.schedule.endDate) {
      through = new Date(s.schedule.endDate);
      days = Math.max(1, Math.round((through - start) / 86400000));
    } else through = new Date(start.getTime() + days * 86400000);
    const fmt = n => "$" + Math.round(n).toLocaleString();
    return {
      markets: mkts.length,
      channels: chans,
      sets,
      campaigns: mkts.length * per,
      daily,
      days,
      total: daily * days,
      through: through.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric"
      }),
      fmt
    };
  }
  canDraft() {
    const s = this.state;
    return s.eventName.trim() && s.landingPage.trim() && this.selChannels().length && this.selMarkets().length;
  }
  reach() {
    const n = this.state.inc.length * 0.62 - this.state.excl.length * 0.18;
    return {
      pct: Math.max(12, Math.min(94, 28 + n * 22)),
      m: (0.6 + n * 0.9).toFixed(1)
    };
  }

  // Display provider ("Meta") → the token the backend/provider proxies expect.
  normProvider(p) {
    const v = String(p || "").toLowerCase();
    if (v === "meta" || v === "facebook" || v === "instagram") return "Facebook";
    if (v === "google") return "Google";
    return p || null;
  }
  provOf(p) {
    p = String(p || "").toLowerCase();
    if (p.includes("google")) return "Google";
    if (p.includes("meta") || p.includes("facebook") || p.includes("instagram")) return "Meta";
    return p ? p[0].toUpperCase() + p.slice(1) : "Other";
  }
  catOf(kind) {
    const k = String(kind || "").toLowerCase();
    if (k.includes("in-market") || k.includes("in_market") || k.includes("inmarket")) return "In-market";
    if (k.includes("affinity")) return "Affinity & interests";
    if (k.includes("interest")) return "Affinity & interests";
    if (k.includes("behav")) return "Behaviors";
    if (k.includes("demo") || k.includes("life") || k.includes("income") || k.includes("homeowner") || k.includes("detailed") || k.includes("parent")) return "Detailed demographics";
    return "Other segments";
  }
  // segRows shape: [[category, [[name, meta, size, id, provider, category], …]], …]
  filterSegs(q) {
    this.setState({
      segQ: q,
      segCat: "All",
      segProv: "All"
    });
    const t = q.trim().toLowerCase();
    if (!t) {
      this.setState({
        segRows: null,
        segErr: null
      });
      return;
    }
    clearTimeout(this._segT);
    this._segT = setTimeout(async () => {
      try {
        const d = await adSvc(`/audiences/catalog?q=${encodeURIComponent(t)}`).getAsync();
        const rows = d && d.segments || [];
        const errs = d && (d.providerErrors || d.ProviderErrors) || [];
        if (!this._alive) return;
        if (!rows.length) {
          this.setState({
            segRows: this.localFilter(t),
            segErr: null
          });
          return;
        }
        const buckets = {};
        rows.forEach(s => {
          const kind = s.kind || s.Kind || s.type || s.Type || "segment";
          const prov = this.provOf(s.provider || s.Provider);
          const cat = this.catOf(kind);
          (buckets[cat] = buckets[cat] || []).push([s.name || s.Name, `${kind} · ${prov}`, s.size || s.Size || "", String(s.id || s.Id || ""), prov, cat]);
        });
        const order = ["In-market", "Affinity & interests", "Behaviors", "Detailed demographics", "Other segments"];
        this.setState({
          segRows: order.filter(c => buckets[c]).map(c => [c, buckets[c]]),
          segErr: errs && errs.length ? errs : null
        });
      } catch (e) {
        if (this._alive) this.setState({
          segRows: this.localFilter(t),
          segErr: null
        });
      }
    }, 300);
  }
  // Offline fallback (catalog endpoint down): SEGS are sample segments with no
  // real provider ids, so id is null — the backend drops them rather than
  // targeting on a bogus id. Real ids come from the /audiences/catalog endpoint.
  localFilter(t) {
    return SEGS.map(c => [c[0], c[1].filter(s => (s[0] + " " + s[3]).toLowerCase().includes(t)).map(s => [s[0], s[1], s[2], null, this.provOf(s[1]), c[0]])]).filter(c => c[1].length);
  }
  // inc holds the FULL segment {name, id, provider, kind} — the id + provider
  // are what Google (numeric segment id) and Meta (interest id) target on, so
  // dropping them (name-only) makes the catalog audience non-functional.
  incHas(name) {
    return this.state.inc.some(a => a.name === name);
  }
  addInc(seg) {
    // seg: [name, meta, size, id, provider, category] from the catalog rows.
    const name = seg[0];
    if (!name || this.incHas(name) || this.state.excl.includes(name)) return;
    this.setState({
      inc: this.state.inc.concat({
        name,
        id: seg[3] || null,
        provider: seg[4] || null,
        kind: seg[5] || null
      })
    });
  }
  openAudPicker() {
    // Always refresh on open so an audience that finished building in the
    // background (or since the last open) shows up as Ready — the list was
    // previously cached after the first open and went stale.
    this.setState({
      audOpen: true
    });
    this.loadAuds();
  }
  loadAuds() {
    return adSvc("/audiences").getAsync().then(d => {
      if (this._alive) this.setState({
        tenantAuds: Array.isArray(d) ? d : []
      });
    }).catch(() => this._alive && this.setState({
      tenantAuds: [],
      audErr: "Couldn't load your audiences."
    }));
  }
  closeAudPicker() {
    this.setState({
      audOpen: false
    });
    clearTimeout(this._audPoll);
  }
  createAud(a) {
    const key = String(a.id);
    this.setState({
      audPending: {
        ...this.state.audPending,
        [key]: true
      },
      audErr: null,
      fwdOff: false
    });
    adSvc(`/audiences/${a.id}/sync-now`).postAsync({}).then(r => {
      if (!this._alive) return;
      if (r && r.forwardingOn === false) {
        const p = {
          ...this.state.audPending
        };
        delete p[key];
        this.setState({
          audPending: p,
          fwdOff: true
        });
      } else {
        this.pollAuds();
      }
    }).catch(() => {
      if (!this._alive) return;
      const p = {
        ...this.state.audPending
      };
      delete p[key];
      this.setState({
        audPending: p,
        audErr: "Couldn't start building — try again."
      });
    });
  }
  pollAuds() {
    clearTimeout(this._audPoll);
    this._audPoll = setTimeout(() => {
      if (!this._alive || !this.state.audOpen) return;
      this.loadAuds().then(() => {
        if (!this._alive) return;
        const pend = {
          ...this.state.audPending
        };
        const done = {
          ...this.state.audDone
        };
        (this.state.tenantAuds || []).forEach(a => {
          const k = String(a.id);
          if (a.adReady && pend[k]) {
            delete pend[k];
            done[k] = true;
          }
        });
        this.setState({
          audPending: pend,
          audDone: done
        });
        if (Object.keys(pend).length) this.pollAuds();
      });
    }, 15000);
  }
  addAudTier(a) {
    const meta = a.metaAudienceId || null,
      google = a.googleUserList || null;
    if (meta && this.state.tiers.some(t => t.meta === meta)) {
      this.closeAudPicker();
      return;
    }
    this.setState({
      tiers: this.state.tiers.concat({
        name: a.name,
        meta,
        google,
        members: a.syncedMembers || a.members
      }),
      audOpen: false
    });
  }
  removeTier(i) {
    this.setState({
      tiers: this.state.tiers.filter((_, idx) => idx !== i)
    });
  }
  createLookalike(a) {
    const key = String(a.id);
    this.setState({
      llBusy: {
        ...this.state.llBusy,
        [key]: true
      },
      audErr: null
    });
    adSvc(`/audiences/${a.id}/lookalike`).postAsync({
      ratioPercent: this.state.llRatio,
      country: "US"
    }).then(() => this.loadAuds()).catch(() => this._alive && this.setState({
      audErr: "Meta couldn't create the lookalike right now — try again shortly."
    })).then(() => {
      if (this._alive) {
        const b = {
          ...this.state.llBusy
        };
        delete b[key];
        this.setState({
          llBusy: b
        });
      }
    });
  }
  rmInc(name) {
    this.setState({
      inc: this.state.inc.filter(x => x.name !== name)
    });
  }
  // ── demographics ──
  togAge(a) {
    const d = this.state.demographics;
    const ageRanges = d.ageRanges.includes(a) ? d.ageRanges.filter(x => x !== a) : d.ageRanges.concat(a);
    this.setState({
      demographics: {
        ...d,
        ageRanges
      },
      profileSaved: false
    });
  }
  togGender(g) {
    const d = this.state.demographics;
    let gender = g === "All" ? ["All"] : d.gender.includes(g) ? d.gender.filter(x => x !== g) : d.gender.filter(x => x !== "All").concat(g);
    if (!gender.length) gender = ["All"];
    this.setState({
      demographics: {
        ...d,
        gender
      },
      profileSaved: false
    });
  }
  togIncome(v) {
    const d = this.state.demographics;
    const householdIncomes = d.householdIncomes.includes(v) ? d.householdIncomes.filter(x => x !== v) : d.householdIncomes.concat(v);
    this.setState({
      demographics: {
        ...d,
        householdIncomes
      },
      profileSaved: false
    });
  }
  togLang(code) {
    const d = this.state.demographics;
    const languages = d.languages.includes(code) ? d.languages.filter(x => x !== code) : d.languages.concat(code);
    this.setState({
      demographics: {
        ...d,
        languages
      },
      profileSaved: false
    });
  }
  rmExcl(name) {
    this.setState({
      excl: this.state.excl.filter(x => x !== name)
    });
  }
  buildRequest() {
    const s = this.state;
    return {
      eventName: s.eventName.trim(),
      landingPage: s.landingPage.trim(),
      channels: this.selChannels(),
      markets: this.selMarkets().map(m => ({
        name: m.name,
        locations: m.zips,
        dailyBudget: Math.max(0, Math.round(Number(s.sameBudget ? s.sharedBudget : m.dailyBudget) || 0))
      })),
      // No custom audiences = single set (empty tiers → flight segments).
      // Adding one runs the segments (implicit "Core", no ids) PLUS each
      // custom audience as its own social set for testing.
      tiers: this.state.tiers.length === 0 ? [] : [{
        name: "Core",
        customAudiences: [],
        interests: [],
        googleUserList: null
      }].concat(this.state.tiers.map(t => ({
        name: t.name,
        customAudiences: t.meta ? [t.meta] : [],
        interests: [],
        googleUserList: t.google || null
      }))),
      demographics: this.state.demographics,
      // Backend targets on provider + id and filters providers by the exact
      // tokens "Google"/"Facebook" (FlightPlanner), so map the display
      // "Meta" back to "Facebook" — otherwise Meta interest segments drop.
      catalogAudiences: s.inc.map(a => ({
        name: a.name,
        id: a.id || null,
        provider: this.normProvider(a.provider),
        kind: a.kind || null
      })),
      adCopy: this.buildAdCopy(),
      searchAds: this.buildSearchAds(),
      schedule: {
        startImmediately: s.schedule.startImmediately,
        noEndDate: s.schedule.noEndDate,
        startDate: s.schedule.startImmediately ? undefined : s.schedule.startDate || undefined,
        endDate: s.schedule.noEndDate ? undefined : s.schedule.endDate || undefined
      }
    };
  }
  // Ad copy feeds responsive display / social / video ads. Send null when the
  // tenant left every field blank (the backend/provider fills a default).
  buildAdCopy() {
    const c = this.state.adCopy || {};
    const any = ["headline", "longHeadline", "description", "businessName", "message"].some(k => (c[k] || "").trim());
    if (!any) return null;
    return {
      headline: (c.headline || "").trim() || undefined,
      longHeadline: (c.longHeadline || "").trim() || undefined,
      description: (c.description || "").trim() || undefined,
      businessName: (c.businessName || "").trim() || undefined,
      message: (c.message || "").trim() || undefined
    };
  }
  // Search runs one responsive search ad per market with the flight's keyword
  // list; headlines/descriptions come from the ad copy (falls back to the
  // flight name so a keyword-only Search still builds a valid ad).
  buildSearchAds() {
    if (!this.selChannels().includes("Search") || !this.state.keywords.length) return [];
    const c = this.state.adCopy || {};
    return [{
      name: "Search",
      adType: "ResponsiveSearchAd",
      headline: (c.headline || "").trim() || this.state.eventName.trim() || undefined,
      longHeadline: (c.longHeadline || "").trim() || undefined,
      headline3: (c.businessName || "").trim() || undefined,
      description: (c.description || "").trim() || undefined,
      description2: (c.message || "").trim() || undefined,
      finalUrl: this.state.landingPage.trim() || undefined,
      keywords: this.state.keywords.map(k => ({
        value: k,
        matchType: "Broad"
      }))
    }];
  }
  // ── creative slots ──
  // One row per (channel, slot). Display and Retarget share slot keys but keep
  // separate channels (separate buckets), so key = channel::slotKey. YouTube +
  // CTV share the single youtube_link video, so they collapse into one row that
  // remembers which rails it feeds (videoChannels) and posts the link to each.
  placements() {
    const chans = this.selChannels();
    const out = [];
    let ytRow = null;
    chans.forEach(c => (PLACEMENTS[c] || []).forEach(p => {
      if (p.kind === "youtube") {
        if (ytRow) {
          ytRow.videoChannels.push(c);
          return;
        }
        ytRow = {
          ...p,
          channel: c,
          videoChannels: [c],
          key: "video::youtube_link"
        };
        out.push(ytRow);
        return;
      }
      out.push({
        ...p,
        channel: c,
        key: c + "::" + p.slotKey
      });
    }));
    if (ytRow) {
      const both = ytRow.videoChannels.indexOf("YouTube") >= 0 && ytRow.videoChannels.indexOf("CTV") >= 0;
      ytRow.name = both ? "YouTube + CTV video" : ytRow.videoChannels[0] === "CTV" ? "CTV / OTT video" : "YouTube video";
    }
    return out;
  }
  // Image slots per creative set. Shared slots (logo / video / youtube link) run
  // once for the whole flight, so they only appear on set A.
  placementsFor(gi) {
    return this.placements().filter(p => gi === 0 || !p.shared);
  }
  openLib(gi, tab) {
    this.setState({
      libOpen: true,
      libGroup: gi,
      libSel: [],
      libTab: tab || "video",
      videoUrl: "",
      videoErr: null
    });
  }
  closeLib() {
    this.setState({
      libOpen: false
    });
  }
  // Ensure a saved draft exists (we need its id to attach creative to S3).
  async ensureDraft() {
    return this.state.draft || (this.state.editId ? {
      id: this.state.editId
    } : await this.createDraft());
  }
  setSlotErr(key, msg) {
    this.setState(st => ({
      slotErr: {
        ...st.slotErr,
        [key]: msg
      }
    }));
  }
  // Extra creative sets suffix the slot key __N (set 1 = bare key); shared
  // slots (logo) are one per ad, never suffixed. Matches the backend's
  // SetIndexOf/StripSetSuffix pairing.
  slotKeyFor(gi, p) {
    return gi > 0 && !p.shared ? `${p.slotKey}__${gi + 1}` : p.slotKey;
  }
  addGroup() {
    const n = this.state.groups.length;
    this.setState({
      groups: this.state.groups.concat({
        name: `Creative set ${String.fromCharCode(65 + n)}`,
        slots: {}
      })
    });
  }
  removeGroup(gi) {
    if (this.state.groups.length <= 1) return;
    this.setState({
      groups: this.state.groups.filter((_, i) => i !== gi)
    });
  }
  clearSlot(gi, key) {
    const groups = this.state.groups.slice();
    const g = {
      ...groups[gi],
      slots: {
        ...groups[gi].slots
      }
    };
    delete g.slots[key];
    groups[gi] = g;
    this.setState({
      groups
    });
  }
  errText(e, fb) {
    try {
      const b = JSON.parse(e.message);
      if (b.error) return b.error;
    } catch (x) {}
    return fb;
  }
  render() {
    const s = this.state;
    if (s.error) return /*#__PURE__*/React.createElement(Error, {
      onRetry: () => this.setState({
        error: false,
        ready: false
      }, () => this.init())
    });
    if (!s.ready) return /*#__PURE__*/React.createElement(Loader, null);
    if (s.applyResult) return this.renderApplyResult();
    const chans = this.selChannels(),
      mkts = this.selMarkets();
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view campaigns-view wa-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns"
      }, "Campaigns"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
        to: "/Campaigns/Flights"
      }, "Flights"), " \xB7 Flight builder"),
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "Flight builder", /*#__PURE__*/React.createElement("span", {
        className: "fb-beta"
      }, "BETA")),
      subtitle: `${STEPS[s.step] ? STEPS[s.step][0] : ""} · step ${s.step + 1} of ${STEPS.length} · nothing launches until Review`
    }), /*#__PURE__*/React.createElement("div", {
      className: "fb-wrap"
    }, /*#__PURE__*/React.createElement("aside", {
      className: "fb-rail"
    }, STEPS.map((st, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      className: `fb-step ${i === s.step ? "on" : ""} ${i < s.step ? "done" : ""}`,
      onClick: () => this.go(i)
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-num"
    }, i + 1), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "fb-lbl"
    }, st[0]), /*#__PURE__*/React.createElement("div", {
      className: "fb-sub"
    }, st[1]))))), /*#__PURE__*/React.createElement("main", {
      className: "fb-main"
    }, this.renderStep()), /*#__PURE__*/React.createElement("aside", {
      className: "fb-sum"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-sumcard"
    }, /*#__PURE__*/React.createElement("h4", null, "Flight summary"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 700,
        fontSize: 15,
        marginBottom: 8
      }
    }, s.eventName || "Untitled flight"), /*#__PURE__*/React.createElement("div", null, chans.map(c => /*#__PURE__*/React.createElement("span", {
      key: c,
      className: "fb-schip"
    }, (CHANNELS.find(x => x[0] === c) || [])[1] || c))), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Channels"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, chans.length)), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Markets"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, mkts.length)), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Audiences"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, s.inc.length)), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Daily / campaign"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, "$", s.sameBudget ? s.sharedBudget : "—")), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Campaigns"), /*#__PURE__*/React.createElement("span", {
      className: "v",
      style: {
        color: "var(--plk-accent,#ff6358)"
      }
    }, this.expectedSpend().campaigns)), /*#__PURE__*/React.createElement("div", {
      className: "fb-sr"
    }, /*#__PURE__*/React.createElement("span", null, "Expected / day"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, this.expectedSpend().fmt(this.expectedSpend().daily))), s.inc.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "fb-reach"
    }, /*#__PURE__*/React.createElement("div", {
      className: "big"
    }, this.reach().m, "M"), /*#__PURE__*/React.createElement("div", {
      className: "fb-note",
      style: {
        color: "var(--plk-accent-ink,#e0473c)"
      }
    }, "est. monthly reach"))), s.note && /*#__PURE__*/React.createElement("p", {
      className: "fb-note",
      style: {
        marginTop: 12
      }
    }, s.note))), s.libOpen && this.renderLib(), s.audOpen && this.renderAudPicker());
  }
  renderAudPicker() {
    const s = this.state;
    const added = new Set(s.tiers.map(t => t.meta).filter(Boolean));
    const auds = s.tenantAuds || [];
    const ready = auds.filter(a => a.adReady && !added.has(a.metaAudienceId));
    const creatable = auds.filter(a => !a.adReady && Number(a.members) > 0);
    const num = v => Number(v) ? Number(v).toLocaleString() : "";
    return /*#__PURE__*/React.createElement("div", {
      className: "fb-ov",
      onClick: () => this.closeAudPicker()
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-modal",
      style: {
        width: "min(560px,96vw)"
      },
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-mh"
    }, /*#__PURE__*/React.createElement("h3", null, "Add a custom audience"), /*#__PURE__*/React.createElement("button", {
      className: "fb-close",
      onClick: () => this.closeAudPicker()
    }, "\xD7")), /*#__PURE__*/React.createElement("div", {
      className: "fb-mbody"
    }, s.fwdOff && /*#__PURE__*/React.createElement("div", {
      className: "fb-buildbanner",
      style: {
        background: "var(--plk-warn-soft,#fbeeda)",
        borderColor: "#efd9ad",
        color: "#7a5310"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: 18
      }
    }, "error_outline"), " Ad-event forwarding is off for this workspace \u2014 turn it on in ", /*#__PURE__*/React.createElement("b", null, "\xA0Manage Data \u2192 Connect\xA0"), " so Plunk can build audiences on Meta & Google. Nothing is created until it's on."), !s.fwdOff && Object.keys(s.audPending).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "fb-buildbanner"
    }, /*#__PURE__*/React.createElement("span", {
      className: "fb-spin"
    }), " Building ", Object.keys(s.audPending).length, " audience", Object.keys(s.audPending).length === 1 ? "" : "s", " on Meta & Google \u2014 this takes ~2 minutes. Keep working; they move to \u201CReady to use\u201D here when done."), s.tenantAuds == null ? /*#__PURE__*/React.createElement(Loader, null) : ready.length === 0 && creatable.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "fb-empty"
    }, s.audErr || "No audiences to use yet.", /*#__PURE__*/React.createElement("div", {
      className: "fb-note",
      style: {
        marginTop: 8
      }
    }, "Create an audience with members in ", /*#__PURE__*/React.createElement("b", null, "Manage Data \u2192 Audiences"), ", then build it for ads here.")) : /*#__PURE__*/React.createElement(React.Fragment, null, ready.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "fb-segcat",
      style: {
        borderRadius: "8px 8px 0 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("span", null, "Ready to use"), /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        letterSpacing: 0,
        fontWeight: 500
      }
    }, "Lookalike ratio\xA0", /*#__PURE__*/React.createElement("select", {
      value: s.llRatio,
      onClick: e => e.stopPropagation(),
      onChange: e => this.setState({
        llRatio: Number(e.target.value)
      }),
      style: {
        fontFamily: "inherit",
        fontSize: 11
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: 1
    }, "1%"), /*#__PURE__*/React.createElement("option", {
      value: 2
    }, "2%"), /*#__PURE__*/React.createElement("option", {
      value: 5
    }, "5%"), /*#__PURE__*/React.createElement("option", {
      value: 10
    }, "10%")))), /*#__PURE__*/React.createElement("div", {
      className: "fb-segs",
      style: {
        marginTop: 0,
        borderRadius: "0 0 8px 8px"
      }
    }, ready.map(a => {
      const busy = s.llBusy[String(a.id)];
      const justMade = s.audDone[String(a.id)];
      return /*#__PURE__*/React.createElement("div", {
        key: String(a.id),
        className: "fb-seg",
        onClick: () => this.addAudTier(a)
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "nm"
      }, a.name, a.lookalike && /*#__PURE__*/React.createElement("span", {
        className: "fb-lltag"
      }, "LAL"), justMade && /*#__PURE__*/React.createElement("span", {
        className: "fb-lltag",
        style: {
          background: "var(--plk-success-soft,#e3f5ea)",
          color: "var(--plk-success,#2f9e5f)"
        }
      }, "\u2713 Created")), /*#__PURE__*/React.createElement("div", {
        className: "mt"
      }, [a.metaAudienceId ? "Meta custom" : "", a.googleUserList ? "Google Customer Match" : ""].filter(Boolean).join(" · ") || (a.lookalike ? "Meta lookalike" : ""))), !a.lookalike && a.metaAudienceId && /*#__PURE__*/React.createElement("button", {
        className: "fb-llbtn",
        onClick: e => {
          e.stopPropagation();
          if (!busy) this.createLookalike(a);
        },
        title: "Create a Meta lookalike from this audience"
      }, busy ? "…" : "＋ Lookalike"), /*#__PURE__*/React.createElement("div", {
        className: "sz"
      }, num(a.syncedMembers || a.members)), /*#__PURE__*/React.createElement("div", {
        className: "pl"
      }, "+"));
    }))), creatable.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "fb-segcat",
      style: {
        marginTop: ready.length ? 12 : 0,
        borderRadius: "8px 8px 0 0"
      }
    }, "Build for ads \u2014 create from your audiences"), /*#__PURE__*/React.createElement("div", {
      className: "fb-segs",
      style: {
        marginTop: 0,
        borderRadius: "0 0 8px 8px"
      }
    }, creatable.map(a => {
      const pending = s.audPending[String(a.id)];
      return /*#__PURE__*/React.createElement("div", {
        key: String(a.id),
        className: `fb-seg ${pending ? "added" : ""}`,
        onClick: () => !pending && this.createAud(a)
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "nm"
      }, a.name), /*#__PURE__*/React.createElement("div", {
        className: "mt"
      }, pending ? "Building on Meta & Google… (a couple of minutes)" : "Create as a custom audience")), /*#__PURE__*/React.createElement("div", {
        className: "sz"
      }, num(a.members)), /*#__PURE__*/React.createElement("div", {
        className: "pl"
      }, pending ? "…" : "+"));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "fb-note",
      style: {
        marginTop: 10
      }
    }, "Custom audiences build from your audience's consented members only.")))));
  }
  renderLib() {
    const s = this.state;
    const ytRow = this.placements().find(p => p.kind === "youtube");
    const rail = ytRow ? ytRow.name : "YouTube video";
    return /*#__PURE__*/React.createElement("div", {
      className: "fb-ov",
      onClick: () => this.closeLib()
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-modal",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-mh"
    }, /*#__PURE__*/React.createElement("h3", null, rail, " link"), /*#__PURE__*/React.createElement("button", {
      className: "fb-close",
      onClick: () => this.closeLib()
    }, "\xD7")), /*#__PURE__*/React.createElement("div", {
      className: "fb-mbody"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-vlink"
    }, /*#__PURE__*/React.createElement("label", {
      className: "fb-vl-label"
    }, "YouTube video link"), /*#__PURE__*/React.createElement("p", {
      className: "fb-note",
      style: {
        marginTop: 0
      }
    }, "Paste the public URL of a video already on your channel \u2014 watch, share, or Shorts. Plunk pulls the video id and its thumbnail automatically; no upload needed.", ytRow && ytRow.videoChannels && ytRow.videoChannels.length > 1 ? " This link runs on both the YouTube and CTV/OTT rails." : ""), /*#__PURE__*/React.createElement("input", {
      className: "fb-input",
      value: s.videoUrl || "",
      autoFocus: true,
      onChange: e => this.setState({
        videoUrl: e.target.value,
        videoErr: null
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.addVideoLink(s.libGroup);
      },
      placeholder: "https://www.youtube.com/watch?v=\u2026"
    }), ytThumb(s.videoUrl) ? /*#__PURE__*/React.createElement("div", {
      className: "fb-vl-prev"
    }, /*#__PURE__*/React.createElement("span", {
      className: "fb-thumb"
    }, /*#__PURE__*/React.createElement("img", {
      src: ytThumb(s.videoUrl),
      alt: "preview"
    }), /*#__PURE__*/React.createElement("span", {
      className: "fb-play"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "play_arrow"))), /*#__PURE__*/React.createElement("span", {
      className: "fb-note"
    }, "Video ", ytId(s.videoUrl), " \u2014 thumbnail synced \u2713")) : null, s.videoErr && /*#__PURE__*/React.createElement("div", {
      className: "fb-vl-err"
    }, s.videoErr))), /*#__PURE__*/React.createElement("div", {
      className: "fb-mf"
    }, /*#__PURE__*/React.createElement("span", {
      className: "fb-note"
    }, ytId(s.videoUrl) ? "Ready to add" : "Paste a link"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "fb-btn",
      onClick: () => this.closeLib()
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "fb-btn primary",
      disabled: !ytId(s.videoUrl) || s.videoBusy,
      onClick: () => this.addVideoLink(s.libGroup)
    }, s.videoBusy ? "Adding…" : "Add video")))));
  }
  renderStep() {
    const s = this.state;
    switch (s.step) {
      case 0:
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
          className: "fb-h1"
        }, "Flight basics"), /*#__PURE__*/React.createElement("p", {
          className: "fb-lead"
        }, "Name the flight, set the landing page, and choose the run window."), /*#__PURE__*/React.createElement("div", {
          className: "fb-card"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-field"
        }, /*#__PURE__*/React.createElement("label", null, "Flight name"), /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          value: s.eventName,
          onChange: e => this.setState({
            eventName: e.target.value
          }),
          placeholder: "Plunk for Interior Designers \u2014 Fall 2026"
        })), /*#__PURE__*/React.createElement("div", {
          className: "fb-field"
        }, /*#__PURE__*/React.createElement("label", null, "Landing page URL"), /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          value: s.landingPage,
          onChange: e => this.setState({
            landingPage: e.target.value
          }),
          placeholder: "https://\u2026"
        })), /*#__PURE__*/React.createElement("div", {
          className: "fb-row2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-field",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("label", null, "Start"), /*#__PURE__*/React.createElement("label", {
          className: "fb-tog"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          checked: s.schedule.startImmediately,
          onChange: e => this.setState({
            schedule: {
              ...s.schedule,
              startImmediately: e.target.checked
            }
          })
        }), " Start immediately"), !s.schedule.startImmediately && /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          type: "date",
          style: {
            marginTop: 6
          },
          value: s.schedule.startDate,
          onChange: e => this.setState({
            schedule: {
              ...s.schedule,
              startDate: e.target.value
            }
          })
        })), /*#__PURE__*/React.createElement("div", {
          className: "fb-field",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("label", null, "End"), /*#__PURE__*/React.createElement("label", {
          className: "fb-tog"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          checked: s.schedule.noEndDate,
          onChange: e => this.setState({
            schedule: {
              ...s.schedule,
              noEndDate: e.target.checked
            }
          })
        }), " No end date"), !s.schedule.noEndDate && /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          type: "date",
          style: {
            marginTop: 6
          },
          value: s.schedule.endDate,
          onChange: e => this.setState({
            schedule: {
              ...s.schedule,
              endDate: e.target.value
            }
          })
        })))), /*#__PURE__*/React.createElement("div", {
          className: "fb-actions"
        }, /*#__PURE__*/React.createElement("button", {
          className: "fb-btn primary",
          onClick: () => this.go(1)
        }, "Next: Channels")));
      case 1:
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
          className: "fb-h1"
        }, "Channels"), /*#__PURE__*/React.createElement("p", {
          className: "fb-lead"
        }, "Pick where this flight runs \u2014 each market fans out into one campaign per channel."), /*#__PURE__*/React.createElement("div", {
          className: "fb-chgrid"
        }, CHANNELS.map(c => /*#__PURE__*/React.createElement("div", {
          key: c[0],
          className: `fb-ch ${s.channels[c[0]] ? "on" : ""}`,
          onClick: () => this.togCh(c[0])
        }, /*#__PURE__*/React.createElement("div", {
          className: "tk"
        }, "\u2713"), /*#__PURE__*/React.createElement("div", {
          className: "fb-ci"
        }, /*#__PURE__*/React.createElement("span", {
          className: "material-icons",
          style: {
            fontSize: 19
          }
        }, "campaign")), /*#__PURE__*/React.createElement("h4", null, c[1]), /*#__PURE__*/React.createElement("p", null, c[2])))), (s.channels.Social || s.channels.SocialVideo) && /*#__PURE__*/React.createElement("div", {
          className: "fb-card",
          style: {
            marginTop: 14
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-cgname",
          style: {
            marginBottom: 4
          }
        }, "Meta connection", /*#__PURE__*/React.createElement("span", {
          className: "fb-note",
          style: {
            fontWeight: 500
          }
        }, "\u2014 Social & Social Video run under your Facebook Page")), /*#__PURE__*/React.createElement("div", {
          className: "fb-row2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-field",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("label", null, "Facebook Page ID ", /*#__PURE__*/React.createElement("span", {
          className: "fb-note"
        }, "(required for Social)")), /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          value: s.metaPageId,
          placeholder: "e.g. 123456789012345",
          onChange: e => this.setState({
            metaPageId: e.target.value
          })
        })), /*#__PURE__*/React.createElement("div", {
          className: "fb-field",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("label", null, "Instagram account ID ", /*#__PURE__*/React.createElement("span", {
          className: "fb-note"
        }, "(optional)")), /*#__PURE__*/React.createElement("input", {
          className: "fb-input",
          value: s.metaInstagramId,
          placeholder: "e.g. 17841400000000000",
          onChange: e => this.setState({
            metaInstagramId: e.target.value
          })
        }))), /*#__PURE__*/React.createElement("p", {
          className: "fb-note",
          style: {
            margin: "8px 0 0"
          }
        }, "Your Page must grant Plunk advertiser access once (Meta Business Settings \u2192 Pages \u2192 Assign partner). Saved to your account and reused across flights.")), /*#__PURE__*/React.createElement("div", {
          className: "fb-actions"
        }, /*#__PURE__*/React.createElement("button", {
          className: "fb-btn primary",
          onClick: () => this.go(2)
        }, "Next: Markets")));
      case 2:
        {
          const rows = (s.markets || []).filter(m => m.include && m.lat != null && m.lng != null).map(m => ({
            lat: m.lat,
            lng: m.lng,
            label: m.name,
            sub: `${m.zips.length} ZIPs`,
            value: 1
          }));
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
            className: "fb-h1"
          }, "Markets & geo"), /*#__PURE__*/React.createElement("p", {
            className: "fb-lead"
          }, "Target your saved markets. The map shows exactly who you'll reach \u2014 no more pasting ZIP lists blind."), /*#__PURE__*/React.createElement("div", {
            className: "fb-geo"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-mapbox"
          }, rows.length ? /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%"
            }
          }, /*#__PURE__*/React.createElement(PostalBubbleMap, {
            rows: rows,
            showLabels: true,
            height: 340
          })) : /*#__PURE__*/React.createElement("div", {
            className: "fb-mapempty"
          }, "Select markets to plot them on the map.", /*#__PURE__*/React.createElement("br", null), "(Markets without stored coordinates won't pin \u2014 the list still targets them.)")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Your markets \xB7 tap to target"), (s.markets || []).map((m, i) => /*#__PURE__*/React.createElement("div", {
            key: m.name,
            className: `fb-mkt ${m.include ? "on" : ""}`
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-chk",
            onClick: () => this.togMkt(i)
          }, m.include ? "✓" : ""), /*#__PURE__*/React.createElement("div", {
            onClick: () => this.togMkt(i),
            style: {
              cursor: "pointer"
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "nm"
          }, m.name), /*#__PURE__*/React.createElement("div", {
            className: "zp"
          }, m.zips.length, " ZIPs")), m.include && /*#__PURE__*/React.createElement("span", {
            className: "bud"
          }, "$", s.sameBudget ? s.sharedBudget : m.dailyBudget, "/day"))))), /*#__PURE__*/React.createElement("div", {
            className: "fb-actions"
          }, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            onClick: () => this.go(3)
          }, "Next: Audiences")));
        }
      case 3:
        {
          const list = s.segRows;
          const hasAud = s.inc.length > 0;
          const r = this.reach();
          const cats = Array.isArray(list) ? list : [];
          const total = cats.reduce((a, c) => a + c[1].length, 0);
          const provCount = {};
          cats.forEach(c => c[1].forEach(row => {
            const p = row[4] || "Other";
            provCount[p] = (provCount[p] || 0) + 1;
          }));
          const provs = Object.keys(provCount);
          const filtered = cats.filter(c => s.segCat === "All" || c[0] === s.segCat).map(c => [c[0], c[1].filter(row => s.segProv === "All" || (row[4] || "Other") === s.segProv)]).filter(c => c[1].length);
          const Chip = (label, active, onClick, count) => /*#__PURE__*/React.createElement("button", {
            className: `fb-catchip ${active ? "on" : ""}`,
            onClick: onClick
          }, label, count != null ? /*#__PURE__*/React.createElement("span", {
            className: "ct"
          }, count) : null);
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
            className: "fb-h1"
          }, "Audiences"), /*#__PURE__*/React.createElement("p", {
            className: "fb-lead"
          }, "Add segments to target and watch estimated reach update live."), /*#__PURE__*/React.createElement("div", {
            className: "fb-aud"
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "fb-field",
            style: {
              margin: 0
            }
          }, /*#__PURE__*/React.createElement("label", null, "Find audience segments"), /*#__PURE__*/React.createElement("input", {
            className: "fb-input",
            value: s.segQ,
            onChange: e => this.filterSegs(e.target.value),
            placeholder: "Try \"interior design\", \"luxury home\", \"in-market furniture\"\u2026"
          })), cats.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow"
          }, Chip("All", s.segCat === "All", () => this.setState({
            segCat: "All"
          }), total), cats.map(c => Chip(c[0], s.segCat === c[0], () => this.setState({
            segCat: c[0]
          }), c[1].length))), provs.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow",
            style: {
              marginTop: 6
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "fb-note",
            style: {
              alignSelf: "center",
              marginRight: 2
            }
          }, "Source"), Chip("All", s.segProv === "All", () => this.setState({
            segProv: "All"
          })), provs.map(p => Chip(p, s.segProv === p, () => this.setState({
            segProv: p
          }), provCount[p])))), s.segErr && /*#__PURE__*/React.createElement("div", {
            className: "fb-note",
            style: {
              margin: "8px 0 0"
            }
          }, "Some providers returned nothing for this term."), cats.length > 0 && provs.length === 1 && /*#__PURE__*/React.createElement("div", {
            className: "fb-note",
            style: {
              margin: "8px 0 0"
            }
          }, "Only ", provs[0], " matched \"", s.segQ, "\" \u2014 try a broader term to pull the other network's segments."), /*#__PURE__*/React.createElement("div", {
            className: "fb-segs"
          }, !list ? /*#__PURE__*/React.createElement("div", {
            className: "fb-seg",
            style: {
              cursor: "default",
              color: "var(--plk-text-muted,#7d7b88)"
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, "search"), /*#__PURE__*/React.createElement("div", {
            className: "mt"
          }, "Search above to browse Google & Meta segments.")) : filtered.length === 0 ? /*#__PURE__*/React.createElement("div", {
            className: "fb-seg",
            style: {
              cursor: "default",
              color: "var(--plk-text-muted,#7d7b88)"
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "mt"
          }, "No segments match \"", s.segQ, "\"", s.segCat !== "All" ? ` in ${s.segCat}` : "", ".")) : filtered.map(cat => /*#__PURE__*/React.createElement(React.Fragment, {
            key: cat[0]
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-segcat"
          }, cat[0]), cat[1].map((seg, i) => {
            const added = this.incHas(seg[0]);
            return /*#__PURE__*/React.createElement("div", {
              key: i,
              className: `fb-seg ${added ? "added" : ""}`,
              onClick: () => !added && this.addInc(seg)
            }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
              className: "nm"
            }, seg[0]), /*#__PURE__*/React.createElement("div", {
              className: "mt"
            }, seg[1])), /*#__PURE__*/React.createElement("div", {
              className: "sz"
            }, seg[2]), /*#__PURE__*/React.createElement("div", {
              className: "pl"
            }, added ? "✓" : "+"));
          }))))), /*#__PURE__*/React.createElement("div", {
            className: "fb-card",
            style: {
              maxWidth: "none",
              margin: 0
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow",
            style: {
              marginTop: 0
            }
          }, "Include"), /*#__PURE__*/React.createElement("div", {
            className: "fb-chips"
          }, s.inc.length ? s.inc.map(c => /*#__PURE__*/React.createElement("span", {
            key: c.name,
            className: "fb-chip",
            title: c.provider ? `${c.provider}${c.id ? " · " + c.id : ""}` : c.name
          }, c.name, /*#__PURE__*/React.createElement("span", {
            className: "fb-x",
            onClick: () => this.rmInc(c.name)
          }, "\xD7"))) : /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "Add segments from the list \u2192")), s.excl.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Exclude"), /*#__PURE__*/React.createElement("div", {
            className: "fb-chips"
          }, s.excl.map(c => /*#__PURE__*/React.createElement("span", {
            key: c,
            className: "fb-chip excl"
          }, c, /*#__PURE__*/React.createElement("span", {
            className: "fb-x",
            onClick: () => this.rmExcl(c)
          }, "\xD7"))))), /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Estimated reach"), /*#__PURE__*/React.createElement("div", {
            className: "fb-gaugebar"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-gaugefill",
            style: {
              width: (hasAud ? r.pct : 0) + "%"
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: "fb-gaugelab"
          }, /*#__PURE__*/React.createElement("span", null, "Narrow"), /*#__PURE__*/React.createElement("span", {
            style: {
              color: "var(--plk-accent-ink,#e0473c)",
              fontWeight: 700
            }
          }, hasAud ? r.m + "M" : "—"), /*#__PURE__*/React.createElement("span", null, "Broad")), /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Custom audiences \u2014 split social to test"), /*#__PURE__*/React.createElement("div", {
            className: "fb-tiers"
          }, s.tiers.map((t, i) => /*#__PURE__*/React.createElement("div", {
            key: i,
            className: "fb-tier on"
          }, /*#__PURE__*/React.createElement("span", {
            className: "fb-tierx",
            onClick: () => this.removeTier(i)
          }, "\xD7"), t.name, /*#__PURE__*/React.createElement("b", null, t.meta ? "Custom audience" : "Google list"))), /*#__PURE__*/React.createElement("div", {
            className: "fb-tier add",
            onClick: () => this.openAudPicker()
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: 16
            }
          }, "\uFF0B"), /*#__PURE__*/React.createElement("b", null, "Add custom audience"))), /*#__PURE__*/React.createElement("div", {
            className: "fb-note",
            style: {
              marginTop: 6
            }
          }, s.tiers.length ? `Your segments run as the base set; social also runs ${s.tiers.length} custom ${s.tiers.length === 1 ? "audience" : "audiences"} as ${s.tiers.length === 1 ? "its own set" : "separate sets"} for testing.` : "Your segments run as the base set. Add a custom audience to run it as its own social set for testing."))), /*#__PURE__*/React.createElement("div", {
            className: "fb-actions"
          }, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            onClick: () => this.go(4)
          }, "Next: Demographics")));
        }
      case 4:
        {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
            className: "fb-h1"
          }, "Demographics"), /*#__PURE__*/React.createElement("p", {
            className: "fb-lead"
          }, "Age, gender, income and language applied to every campaign this flight fans out. Seeded from your saved targeting profile."), /*#__PURE__*/React.createElement("div", {
            className: "fb-card"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow",
            style: {
              marginTop: 0
            }
          }, "Age ranges *"), /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow"
          }, AGES.map(a => /*#__PURE__*/React.createElement("button", {
            key: a,
            className: `fb-catchip ${s.demographics.ageRanges.includes(a) ? "on" : ""}`,
            onClick: () => this.togAge(a)
          }, a))), /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Gender"), /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow"
          }, GENDERS.map(g => /*#__PURE__*/React.createElement("button", {
            key: g,
            className: `fb-catchip ${s.demographics.gender.includes(g) ? "on" : ""}`,
            onClick: () => this.togGender(g)
          }, g))), /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Household income ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(Google Display/Search/Video \xB7 optional)")), /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow"
          }, INCOMES.map(v => /*#__PURE__*/React.createElement("button", {
            key: v,
            className: `fb-catchip ${s.demographics.householdIncomes.includes(v) ? "on" : ""}`,
            onClick: () => this.togIncome(v)
          }, v))), /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow"
          }, "Languages ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(optional \xB7 empty = all)")), /*#__PURE__*/React.createElement("div", {
            className: "fb-catrow"
          }, LANGS.map(([label, code]) => /*#__PURE__*/React.createElement("button", {
            key: code,
            className: `fb-catchip ${s.demographics.languages.includes(code) ? "on" : ""}`,
            onClick: () => this.togLang(code)
          }, label))), !s.demographics.ageRanges.length && /*#__PURE__*/React.createElement("p", {
            className: "fb-note",
            style: {
              color: "var(--plk-danger,#b42318)",
              margin: "8px 0 0"
            }
          }, "Pick at least one age range \u2014 Google video (YouTube/CTV) requires it."), /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 14,
              borderTop: "1px solid var(--plk-border,#e7e2dc)",
              paddingTop: 12
            }
          }, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn",
            disabled: s.savingProfile,
            onClick: this.saveProfile
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 16,
              verticalAlign: "middle",
              marginRight: 5
            }
          }, "bookmark_add"), s.savingProfile ? "Saving…" : "Save as my targeting profile"), /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, s.profileSaved ? "✓ Saved — new flights start from this." : "Sets the default demographics every new flight starts from."))), /*#__PURE__*/React.createElement("div", {
            className: "fb-actions"
          }, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            onClick: () => this.go(5)
          }, "Next: Creative")));
        }
      case 5:
        {
          const chans = this.selChannels();
          const placements = this.placements();
          const hasSearch = chans.includes("Search");
          const hasImageOrVideo = placements.length > 0;
          const cp = s.adCopy || {};
          const setCopy = (k, v) => this.setState({
            adCopy: {
              ...this.state.adCopy,
              [k]: v
            }
          });
          // One upload/link tile per slot.
          const slotTile = (gi, p, g) => {
            const asset = s.assets.find(a => a.id === g.slots[p.key]);
            const errKey = `${gi}:${p.key}`;
            const err = s.slotErr[errKey];
            const uploading = s.uploadingSlot === errKey;
            const thumb = asset && asset.url ? /*#__PURE__*/React.createElement("span", {
              className: "fb-thumb"
            }, /*#__PURE__*/React.createElement("img", {
              src: asset.url,
              alt: asset.name
            }), (asset.video || asset.videoFile) && /*#__PURE__*/React.createElement("span", {
              className: "fb-play"
            }, /*#__PURE__*/React.createElement("span", {
              className: "material-icons"
            }, "play_arrow"))) : asset ? /*#__PURE__*/React.createElement("span", {
              className: "snm"
            }, asset.name) : null;
            const clearX = asset ? /*#__PURE__*/React.createElement("span", {
              className: "fb-slotx",
              title: "Remove",
              onClick: e => {
                e.preventDefault();
                e.stopPropagation();
                this.clearSlot(gi, p.key);
              }
            }, "\xD7") : null;
            let control;
            if (p.kind === "youtube") {
              control = /*#__PURE__*/React.createElement("div", {
                className: `fb-slot ${asset ? "filled" : ""}`,
                onClick: () => this.openLib(gi, "video"),
                title: asset ? "Replace the video link" : "Add a public YouTube link"
              }, clearX, asset ? thumb : uploading ? "Saving…" : "+ Add YouTube link");
            } else if (p.kind === "video") {
              control = /*#__PURE__*/React.createElement("label", {
                className: `fb-slot ${asset ? "filled" : ""}`,
                title: asset ? "Replace video" : "Upload MP4/MOV"
              }, clearX, asset ? thumb : uploading ? "Uploading…" : "+ Upload video", /*#__PURE__*/React.createElement("input", {
                type: "file",
                accept: "video/mp4,video/quicktime",
                hidden: true,
                onChange: e => {
                  const f = e.target.files && e.target.files[0];
                  e.target.value = "";
                  this.uploadVideo(gi, p, f);
                }
              }));
            } else {
              control = /*#__PURE__*/React.createElement("label", {
                className: `fb-slot ${asset ? "filled" : ""}`,
                title: asset ? "Replace image" : "Upload a JPG or PNG"
              }, clearX, asset ? thumb : uploading ? "Uploading…" : "+ Upload image", /*#__PURE__*/React.createElement("input", {
                type: "file",
                accept: "image/png,image/jpeg",
                hidden: true,
                onChange: e => {
                  const f = e.target.files && e.target.files[0];
                  e.target.value = "";
                  this.uploadSlot(gi, p, f);
                }
              }));
            }
            return /*#__PURE__*/React.createElement("div", {
              key: p.key,
              className: "fb-p"
            }, /*#__PURE__*/React.createElement("div", {
              className: "ph"
            }, /*#__PURE__*/React.createElement("b", null, p.name, p.optional ? "" : " *"), /*#__PURE__*/React.createElement("span", null, p.dims)), control, err && /*#__PURE__*/React.createElement("div", {
              className: "fb-slot-err"
            }, err));
          };
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
            className: "fb-h1"
          }, "Creative"), /*#__PURE__*/React.createElement("p", {
            className: "fb-lead"
          }, "Upload the exact images each channel needs \u2014 every slot uploads to public storage and its URL is what Google and Meta ingest. Add more than one set to A/B test creative."), (hasImageOrVideo || hasSearch) && /*#__PURE__*/React.createElement("div", {
            className: "fb-card",
            style: {
              marginBottom: 14
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-cgname",
            style: {
              marginBottom: 10
            }
          }, "Ad copy", /*#__PURE__*/React.createElement("span", {
            className: "fb-note",
            style: {
              fontWeight: 500
            }
          }, "\u2014 shared across every ad in this flight")), /*#__PURE__*/React.createElement("div", {
            className: "fb-row2"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-field"
          }, /*#__PURE__*/React.createElement("label", null, "Headline ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(", (cp.headline || "").length, "/30)")), /*#__PURE__*/React.createElement("input", {
            className: "fb-input",
            maxLength: 30,
            value: cp.headline,
            onChange: e => setCopy("headline", e.target.value),
            placeholder: "Designed for the way you live"
          })), /*#__PURE__*/React.createElement("div", {
            className: "fb-field"
          }, /*#__PURE__*/React.createElement("label", null, "Business name ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(\u226425)")), /*#__PURE__*/React.createElement("input", {
            className: "fb-input",
            maxLength: 25,
            value: cp.businessName,
            onChange: e => setCopy("businessName", e.target.value),
            placeholder: "Robb & Stucky"
          }))), /*#__PURE__*/React.createElement("div", {
            className: "fb-field"
          }, /*#__PURE__*/React.createElement("label", null, "Long headline ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(", (cp.longHeadline || "").length, "/90)")), /*#__PURE__*/React.createElement(GrowText, {
            single: true,
            minLines: 2,
            maxLength: 90,
            value: cp.longHeadline,
            onChange: v => setCopy("longHeadline", v),
            placeholder: "Explore the fall collection at your nearest showroom"
          })), /*#__PURE__*/React.createElement("div", {
            className: "fb-field"
          }, /*#__PURE__*/React.createElement("label", null, "Description ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(", (cp.description || "").length, "/90)")), /*#__PURE__*/React.createElement(GrowText, {
            single: true,
            minLines: 2,
            maxLength: 90,
            value: cp.description,
            onChange: v => setCopy("description", v),
            placeholder: "Handcrafted furniture, in-home design, and more."
          })), (chans.includes("Social") || chans.includes("SocialVideo")) && /*#__PURE__*/React.createElement("div", {
            className: "fb-field"
          }, /*#__PURE__*/React.createElement("label", null, "Social post text ", /*#__PURE__*/React.createElement("span", {
            className: "fb-note"
          }, "(Facebook/Instagram)")), /*#__PURE__*/React.createElement(GrowText, {
            minLines: 3,
            maxLength: 2000,
            value: cp.message,
            onChange: v => setCopy("message", v),
            placeholder: "Fall styles are here \u2014 book a design consult today."
          })), /*#__PURE__*/React.createElement("p", {
            className: "fb-note",
            style: {
              margin: 0
            }
          }, "Leave blank to let the provider generate copy. YouTube/CTV video ads need at least a headline + description.")), hasImageOrVideo && s.prefillImage && this.placementsFor(0).some(p => p.ratio && !p.optional && !p.kind) && /*#__PURE__*/React.createElement("div", {
            className: "fb-callout",
            style: {
              display: "flex",
              gap: 12,
              alignItems: "center",
              marginBottom: 12
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: s.prefillImage,
            alt: "",
            style: {
              width: 56,
              height: 56,
              objectFit: "cover",
              borderRadius: 6
            }
          }), /*#__PURE__*/React.createElement("div", {
            style: {
              flex: 1
            }
          }, "The ad piece's picture from the Content Hub. Put it in every image slot, cropped to each shape?"), /*#__PURE__*/React.createElement("button", {
            className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
            disabled: !!s.prefillBusy || !this.canDraft(),
            title: this.canDraft() ? "" : "Name the flight, add the landing page and pick a market first",
            onClick: this.fillPrefillImage
          }, s.prefillBusy ? "Filling…" : "Fill the slots")), hasImageOrVideo && s.groups.map((grp, gi) => {
            const setPlaces = this.placementsFor(gi);
            if (!setPlaces.length) return null;
            const feeders = [];
            const seen = {};
            setPlaces.forEach(p => {
              const lbl = p.videoChannels ? p.videoChannels.join(" + ") : p.channel;
              if (!seen[lbl]) {
                seen[lbl] = 1;
                feeders.push(lbl);
              }
            });
            return /*#__PURE__*/React.createElement("div", {
              key: gi,
              className: "fb-cgroup"
            }, /*#__PURE__*/React.createElement("div", {
              className: "fb-cghead"
            }, /*#__PURE__*/React.createElement("div", {
              className: "fb-cgname"
            }, /*#__PURE__*/React.createElement("span", {
              className: "fb-cgset"
            }, String.fromCharCode(65 + gi)), grp.name, /*#__PURE__*/React.createElement("span", {
              className: "fb-note",
              style: {
                fontWeight: 500
              }
            }, "\u2014 ", feeders.join(" · "))), s.groups.length > 1 && /*#__PURE__*/React.createElement("button", {
              className: "fb-btn",
              style: {
                padding: "6px 11px"
              },
              onClick: () => this.removeGroup(gi)
            }, "Remove set")), /*#__PURE__*/React.createElement("div", {
              className: "fb-plc"
            }, setPlaces.map(p => slotTile(gi, p, grp))));
          }), hasImageOrVideo && /*#__PURE__*/React.createElement("button", {
            className: "fb-btn fb-addset",
            style: {
              marginBottom: 14
            },
            onClick: () => this.addGroup()
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 17,
              verticalAlign: "middle",
              marginRight: 5
            }
          }, "add"), "Add another creative set"), hasSearch && /*#__PURE__*/React.createElement("div", {
            className: "fb-card",
            style: {
              marginBottom: 14
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-cgname",
            style: {
              marginBottom: 6
            }
          }, "Search keywords", /*#__PURE__*/React.createElement("span", {
            className: "fb-note",
            style: {
              fontWeight: 500
            }
          }, "\u2014 intent terms that trigger your Google Search ad")), /*#__PURE__*/React.createElement("div", {
            className: "fb-field",
            style: {
              marginBottom: 8
            }
          }, /*#__PURE__*/React.createElement("textarea", {
            className: "fb-input",
            rows: 3,
            value: s.keywordInput,
            onChange: e => this.setState({
              keywordInput: e.target.value
            }),
            onKeyDown: e => {
              if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.addKeywords(s.keywordInput);
              }
            },
            placeholder: "Paste or type keywords — one per line or comma-separated\ne.g. luxury furniture, interior design naples, custom sofas"
          })), /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            style: {
              padding: "6px 12px",
              marginBottom: 10
            },
            onClick: () => this.addKeywords(s.keywordInput)
          }, "Add keywords"), s.keywords.length > 0 && /*#__PURE__*/React.createElement("div", {
            className: "fb-tiers"
          }, s.keywords.map(k => /*#__PURE__*/React.createElement("div", {
            key: k,
            className: "fb-tier on"
          }, /*#__PURE__*/React.createElement("span", {
            className: "fb-tierx",
            onClick: () => this.rmKeyword(k)
          }, "\xD7"), k))), /*#__PURE__*/React.createElement("p", {
            className: "fb-note",
            style: {
              marginBottom: 0
            }
          }, s.keywords.length ? `${s.keywords.length} keyword${s.keywords.length === 1 ? "" : "s"} — broad match. The ad text comes from the Ad copy above.` : "Add at least one keyword — Search ads won't run without them.")), !hasImageOrVideo && !hasSearch && /*#__PURE__*/React.createElement("div", {
            className: "fb-card"
          }, /*#__PURE__*/React.createElement("p", {
            className: "fb-note",
            style: {
              margin: 0
            }
          }, "Pick at least one channel in the Channels step to add creative.")), this.isLiveFlight() && /*#__PURE__*/React.createElement("div", {
            className: "fb-callout",
            style: {
              background: "var(--plk-warn-soft,#fbeeda)",
              borderColor: "#efd9ad",
              color: "#7a5310"
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, "info"), /*#__PURE__*/React.createElement("div", null, "Showing this flight's current creative. Swapping the ", /*#__PURE__*/React.createElement("b", null, "video"), " here applies to the live campaigns on save. Image creative isn't re-applied on a live flight yet \u2014 use per-campaign edit for those.")), /*#__PURE__*/React.createElement("div", {
            className: "fb-callout"
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, "info"), /*#__PURE__*/React.createElement("div", null, "Each slot takes a correctly-shaped image (a landscape won't fit a square slot). Upload the size shown on each tile; slots marked optional can be left empty.")), /*#__PURE__*/React.createElement("div", {
            className: "fb-actions"
          }, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            onClick: () => this.go(6)
          }, "Next: Budget")));
        }
      case 6:
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
          className: "fb-h1"
        }, "Budget & schedule"), /*#__PURE__*/React.createElement("p", {
          className: "fb-lead"
        }, "Set a daily budget per campaign: each channel runs its own campaign in every market. Pacing spreads spend evenly with a safety cap."), /*#__PURE__*/React.createElement("div", {
          className: "fb-card"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-field"
        }, /*#__PURE__*/React.createElement("label", null, "Daily budget per campaign"), /*#__PURE__*/React.createElement("input", {
          type: "range",
          className: "fb-slider",
          min: "3",
          max: "40",
          value: s.sharedBudget,
          onChange: e => this.setState({
            sharedBudget: Number(e.target.value)
          })
        }), /*#__PURE__*/React.createElement("div", {
          className: "fb-gaugelab"
        }, /*#__PURE__*/React.createElement("span", null, "$3"), /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 16,
            fontWeight: 700,
            color: "var(--plk-text,#1c1b22)",
            fontFamily: "ui-monospace,Menlo,monospace"
          }
        }, "$", s.sharedBudget), /*#__PURE__*/React.createElement("span", null, "$40"))), /*#__PURE__*/React.createElement("div", {
          className: "fb-row2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "fb-field",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("label", null, "Pacing"), /*#__PURE__*/React.createElement("select", {
          className: "fb-input",
          value: s.pacing,
          onChange: e => this.setState({
            pacing: e.target.value
          })
        }, /*#__PURE__*/React.createElement("option", null, "Standard (even)"), /*#__PURE__*/React.createElement("option", null, "Accelerated"))))), (() => {
          const x = this.expectedSpend();
          if (!x.campaigns) return null;
          return /*#__PURE__*/React.createElement("div", {
            className: "fb-card fb-expect"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-eyebrow",
            style: {
              marginTop: 0
            }
          }, "What this adds up to"), /*#__PURE__*/React.createElement("div", {
            className: "fb-expect-row"
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "big"
          }, x.fmt(x.daily)), /*#__PURE__*/React.createElement("div", {
            className: "fb-note"
          }, "per day, all campaigns")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "big"
          }, x.campaigns), /*#__PURE__*/React.createElement("div", {
            className: "fb-note"
          }, "campaigns: ", x.markets, " market", x.markets === 1 ? "" : "s", " x ", x.channels, " channel", x.channels === 1 ? "" : "s", x.sets > 1 ? ` x ${x.sets} audience sets` : "")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "big"
          }, x.fmt(x.total)), /*#__PURE__*/React.createElement("div", {
            className: "fb-note"
          }, "about, over ", x.days, " days through ", x.through))), /*#__PURE__*/React.createElement("p", {
            className: "fb-note",
            style: {
              margin: "10px 0 0"
            }
          }, "The budget above is per campaign, so every channel bills its own budget in each market."));
        })(), /*#__PURE__*/React.createElement("div", {
          className: "fb-actions"
        }, /*#__PURE__*/React.createElement("button", {
          className: "fb-btn primary",
          onClick: () => this.go(7)
        }, "Next: Review")));
      case 7:
        {
          const live = this.isLiveFlight();
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
            className: "fb-h1"
          }, live ? "Review & save" : "Review & launch"), /*#__PURE__*/React.createElement("p", {
            className: "fb-lead"
          }, live ? "Save applies your changes to this flight's live campaigns — no new campaigns are created." : "Create the draft, validate, then launch to fan the flight into campaigns."), /*#__PURE__*/React.createElement("div", {
            className: "fb-card"
          }, /*#__PURE__*/React.createElement("div", {
            className: "fb-sr",
            style: {
              borderTop: "none",
              paddingTop: 0
            }
          }, /*#__PURE__*/React.createElement("span", null, "Flight"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, s.eventName || "—")), /*#__PURE__*/React.createElement("div", {
            className: "fb-sr"
          }, /*#__PURE__*/React.createElement("span", null, "Channels"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, this.selChannels().join(" · ") || "—")), /*#__PURE__*/React.createElement("div", {
            className: "fb-sr"
          }, /*#__PURE__*/React.createElement("span", null, "Markets"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, this.selMarkets().map(m => m.name).join(", ") || "—")), /*#__PURE__*/React.createElement("div", {
            className: "fb-sr"
          }, /*#__PURE__*/React.createElement("span", null, "Audiences"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, s.inc.length, " include")), /*#__PURE__*/React.createElement("div", {
            className: "fb-sr"
          }, /*#__PURE__*/React.createElement("span", null, "Daily budget per campaign"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, s.sameBudget ? `$${s.sharedBudget}` : "per market")), (() => {
            const x = this.expectedSpend();
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
              className: "fb-sr"
            }, /*#__PURE__*/React.createElement("span", null, live ? "Live campaigns" : "Campaigns to create"), /*#__PURE__*/React.createElement("span", {
              className: "v",
              style: {
                color: "var(--plk-accent,#ff6358)"
              }
            }, x.campaigns)), /*#__PURE__*/React.createElement("div", {
              className: "fb-sr"
            }, /*#__PURE__*/React.createElement("span", null, "Expected spend"), /*#__PURE__*/React.createElement("span", {
              className: "v"
            }, "up to ", x.fmt(x.daily), "/day \xB7 about ", x.fmt(x.total), " through ", x.through)));
          })(), s.draft && !live && /*#__PURE__*/React.createElement("div", {
            className: "fb-sr"
          }, /*#__PURE__*/React.createElement("span", null, "Draft"), /*#__PURE__*/React.createElement("span", {
            className: "v"
          }, "#", String(s.draft.id), " created"))), live && /*#__PURE__*/React.createElement("div", {
            className: "fb-callout"
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, "info"), /*#__PURE__*/React.createElement("div", null, "Editing a live flight applies ", /*#__PURE__*/React.createElement("b", null, "budget"), ", ", /*#__PURE__*/React.createElement("b", null, "audience"), ", ", /*#__PURE__*/React.createElement("b", null, "demographics"), ", ", /*#__PURE__*/React.createElement("b", null, "geo/ZIP"), ", ", /*#__PURE__*/React.createElement("b", null, "interest targets"), ", ", /*#__PURE__*/React.createElement("b", null, "ad copy + display creative"), ", and ", /*#__PURE__*/React.createElement("b", null, "video-creative"), " changes to the running campaigns. Adding/removing an entire market and Meta (social) image creative aren't applied on a live flight yet \u2014 use per-campaign edit for those.")), s.report && (() => {
            // Errors come at two levels, both lists of {field, message}
            // objects: flight-level (report.flightErrors) and per-cell
            // (report.cells[].errors on invalid cells). Pull the human
            // message from each so we never render raw objects, and dedup
            // identical per-cell messages (the same issue repeats across
            // every market × tier) — prefix by channel so it reads clearly.
            const msgOf = e => typeof e === "string" ? e : e && (e.message || e.Message || e.error || e.Error) || "";
            const errs = (s.report.flightErrors || s.report.FlightErrors || []).map(msgOf).filter(Boolean);
            const seen = {};
            (s.report.cells || s.report.Cells || []).forEach(c => {
              if ((c.isValid ?? c.IsValid) !== false) return;
              const ch = c.channel || c.Channel || "";
              (c.errors || c.Errors || []).forEach(e => {
                const m = msgOf(e);
                if (!m) return;
                const line = ch ? `${ch}: ${m}` : m;
                if (seen[line]) return;
                seen[line] = 1;
                errs.push(line);
              });
            });
            // The report carries isValid — a passing Validate has empty
            // errors, so gate on validity, not the presence of arrays.
            const valid = s.report.isValid ?? s.report.IsValid;
            if (valid === true && !errs.length) {
              return /*#__PURE__*/React.createElement("div", {
                className: "fb-callout",
                style: {
                  background: "var(--plk-success-soft,#e3f5ea)",
                  borderColor: "var(--plk-success,#2f9e5f)",
                  color: "var(--plk-success,#2f9e5f)"
                }
              }, /*#__PURE__*/React.createElement("span", {
                className: "material-icons",
                style: {
                  fontSize: 18
                }
              }, "check_circle"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Validation passed"), " \u2014 ", s.report.campaignCount || s.report.CampaignCount || this.selChannels().length * this.selMarkets().length, " campaign", (s.report.campaignCount || s.report.CampaignCount) === 1 ? "" : "s", " ready to launch."));
            }
            return /*#__PURE__*/React.createElement("div", {
              className: "fb-callout",
              style: {
                background: "var(--plk-danger-soft,#fbe6e5)",
                borderColor: "var(--plk-danger,#d64541)",
                color: "var(--plk-danger,#d64541)"
              }
            }, /*#__PURE__*/React.createElement("span", {
              className: "material-icons",
              style: {
                fontSize: 18
              }
            }, "error_outline"), /*#__PURE__*/React.createElement("div", null, errs.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, "Couldn't launch \u2014 fix these:"), /*#__PURE__*/React.createElement("ul", {
              style: {
                margin: "6px 0 0",
                paddingLeft: 18
              }
            }, errs.map((m, i) => /*#__PURE__*/React.createElement("li", {
              key: i
            }, m)))) : "Validation flagged items, but no detail was returned. Run Validate again to see specifics."));
          })(), s.report && (s.report.warnings || s.report.Warnings || []).length > 0 && /*#__PURE__*/React.createElement("div", {
            className: "fb-callout",
            style: {
              background: "var(--plk-warning-soft,#fff4e0)",
              borderColor: "var(--plk-warning,#d98a00)",
              color: "var(--plk-warning-ink,#8a5a00)"
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, "info"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Worth knowing before launch"), /*#__PURE__*/React.createElement("ul", {
            style: {
              margin: "6px 0 0",
              paddingLeft: 18
            }
          }, (s.report.warnings || s.report.Warnings).map((w, i) => /*#__PURE__*/React.createElement("li", {
            key: i
          }, typeof w === "string" ? w : w.message || w.Message))))), !this.canDraft() && /*#__PURE__*/React.createElement("p", {
            className: "fb-note"
          }, "Add a name, landing page, \u22651 channel and \u22651 market to continue."), s.note && /*#__PURE__*/React.createElement("div", {
            className: "fb-callout",
            style: {
              background: /couldn't|error|fail|try again/i.test(s.note) ? "var(--plk-danger-soft,#fbe6e5)" : "var(--plk-success-soft,#e3f5ea)",
              borderColor: /couldn't|error|fail|try again/i.test(s.note) ? "var(--plk-danger,#d64541)" : "var(--plk-success,#2f9e5f)",
              color: /couldn't|error|fail|try again/i.test(s.note) ? "var(--plk-danger,#d64541)" : "var(--plk-success,#2f9e5f)"
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "material-icons",
            style: {
              fontSize: 18
            }
          }, /couldn't|error|fail|try again/i.test(s.note) ? "error_outline" : "check_circle"), /*#__PURE__*/React.createElement("div", null, s.note)), /*#__PURE__*/React.createElement("div", {
            className: "fb-actions"
          }, live ? /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            disabled: !this.canDraft() || s.applying,
            onClick: this.applyEdit
          }, s.applying ? "Saving…" : "Save changes") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
            className: "fb-btn",
            disabled: !this.canDraft() || s.busy || s.validating,
            onClick: this.validate
          }, s.validating ? "Validating…" : "Run validation"), /*#__PURE__*/React.createElement("button", {
            className: "fb-btn primary",
            disabled: !s.draft || s.submitting,
            onClick: this.submit
          }, s.submitting ? "Launching…" : s.editId ? "Save & launch" : "Launch flight"))));
        }
      default:
        return null;
    }
  }
  // Fix guidance for a failed cell's provider reason.
  // Post-save screen for a live-flight edit — mirrors the launch progress. The
  // apply is fire-and-forget (enqueues per-dimension updates to the worker), so
  // this confirms what's syncing rather than polling per-cell.
  renderApplyResult() {
    const r = this.state.applyResult || {};
    const rows = [["Daily budget", r.budgetUpdates], ["Audiences (Meta)", r.audienceUpdates], ["Demographics", r.demoUpdates], ["Geo / markets", r.locationUpdates], ["Interest targets", r.targetUpdates], ["Interest targets (Meta)", r.metaTargetUpdates], ["Display creative", r.creativeImageUpdates], ["Video creative", r.creativeUpdates], ["New campaigns", r.newCampaigns, "Launching"]].filter(x => Number(x[1]) > 0);
    const total = rows.reduce((a, x) => a + Number(x[1]), 0);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view campaigns-view wa-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "territory-detail-head"
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-back",
      onClick: () => this.props.history.push("/Campaigns/Flights")
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "arrow_back")), /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, this.state.eventName || "Flight"))), /*#__PURE__*/React.createElement("div", {
      className: "fb-prog"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-prog-hero"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-ring done"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fb-ring-in"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: 32,
        color: "var(--plk-success,#2f9e5f)"
      }
    }, "check"))), /*#__PURE__*/React.createElement("h1", {
      className: "fb-h1",
      style: {
        marginBottom: 6
      }
    }, total ? "Changes saved" : "Nothing to change"), /*#__PURE__*/React.createElement("p", {
      className: "fb-lead",
      style: {
        margin: 0
      }
    }, total ? "Your edits are syncing to the live campaigns — this usually takes a few minutes. You can leave this page; it continues server-side." : "No changes were detected — the flight already matches what's live.")), total > 0 && /*#__PURE__*/React.createElement("div", {
      className: "fb-prog-list"
    }, rows.map(([label, count, verb], i) => /*#__PURE__*/React.createElement("div", {
      className: "fb-prog-row",
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      className: "fb-pi ok"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "check")), /*#__PURE__*/React.createElement("div", {
      className: "fb-prog-meta"
    }, /*#__PURE__*/React.createElement("b", null, label), /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "inherit",
        wordBreak: "normal"
      }
    }, verb || "Syncing to", " ", count, " campaign", count === 1 ? "" : "s")), /*#__PURE__*/React.createElement("span", {
      className: "fb-prog-st created"
    }, "Queued")))), /*#__PURE__*/React.createElement("div", {
      className: "fb-actions",
      style: {
        justifyContent: "center",
        marginTop: 18
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "fb-btn primary",
      onClick: () => this.props.history.push(`/Campaigns/flight/${this.state.editId}`)
    }, "View flight"), /*#__PURE__*/React.createElement("button", {
      className: "fb-btn",
      onClick: () => this.setState({
        applyResult: null,
        note: null
      })
    }, "Keep editing"), /*#__PURE__*/React.createElement("button", {
      className: "fb-btn",
      onClick: () => this.props.history.push("/Campaigns/Flights")
    }, "Back to campaigns"))));
  }
}
export default withRouter(FlightBuilderView);